/* ============================================================
   Award Builder — behaviour (ported from prototype)
   Data (backgrounds, fonts, awards, months, colours) is read
   from an injected JSON block (#awb-data) populated by Liquid
   from metaobjects + section settings. If that is missing or
   empty, it falls back to the SEED data below, so the builder
   always renders even before any real data is loaded.

   IDs in the markup are prefixed "awb-"; the $ helper adds it,
   so the ported logic can keep using short ids like $("bg").
   ============================================================ */
(function(){
"use strict";

var root = document.querySelector(".awb-root");
if(!root) return;

var $ = function(id){ return document.getElementById("awb-" + id); };

/* ---------------- SEED DATA (fallback) ---------------- */
var SEED = {
  backgrounds: [
    {id:"rd-splat", name:"Red Fury", cat:"Grunge", css:"radial-gradient(120% 90% at 32% 18%, rgba(255,74,60,.62), transparent 58%), radial-gradient(95% 80% at 82% 92%, rgba(96,0,6,.85), transparent 62%), linear-gradient(158deg,#C31220 0%,#8E0A16 46%,#340407 100%)"},
    {id:"gd-black", name:"Gold Standard", cat:"Grunge", css:"radial-gradient(105% 78% at 26% 24%, rgba(240,182,44,.5), transparent 56%), radial-gradient(90% 85% at 78% 88%, rgba(120,80,0,.55), transparent 60%), linear-gradient(162deg,#171310 0%,#0C0A08 55%,#000 100%)"},
    {id:"flood", name:"Floodlight", cat:"Stadium", css:"radial-gradient(58% 34% at 15% 14%, rgba(255,255,255,.55), transparent 55%), radial-gradient(58% 34% at 85% 14%, rgba(255,255,255,.5), transparent 55%), radial-gradient(120% 70% at 50% 100%, rgba(40,70,120,.55), transparent 62%), linear-gradient(178deg,#0B1018 0%,#131C29 50%,#05070B 100%)"},
    {id:"night-t", name:"Night Terrace", cat:"Stadium", css:"radial-gradient(90% 55% at 50% 8%, rgba(90,150,255,.4), transparent 60%), linear-gradient(170deg,#080D16 0%,#101B2E 48%,#04060A 100%)"},
    {id:"bl-steel", name:"Blue Steel", cat:"Colour", css:"radial-gradient(110% 85% at 30% 22%, rgba(70,150,255,.5), transparent 58%), linear-gradient(155deg,#0F3D80 0%,#0A2450 50%,#040D1F 100%)"},
    {id:"em-green", name:"Emerald", cat:"Colour", css:"radial-gradient(110% 85% at 32% 20%, rgba(60,220,140,.42), transparent 58%), linear-gradient(158deg,#0C4A2C 0%,#083019 52%,#020C06 100%)"},
    {id:"claret", name:"Claret & Blue", cat:"Colour", css:"radial-gradient(95% 75% at 25% 20%, rgba(140,25,60,.75), transparent 60%), radial-gradient(90% 70% at 80% 85%, rgba(20,50,130,.75), transparent 60%), linear-gradient(160deg,#4A0A22 0%,#1A1436 60%,#06060F 100%)"},
    {id:"purple-r", name:"Royal Purple", cat:"Colour", css:"radial-gradient(110% 82% at 30% 20%, rgba(170,90,255,.45), transparent 58%), linear-gradient(158deg,#3A0F62 0%,#22083C 52%,#0A0313 100%)"},
    {id:"mono", name:"Monochrome", cat:"Grunge", css:"radial-gradient(110% 85% at 30% 20%, rgba(255,255,255,.32), transparent 56%), linear-gradient(160deg,#3A3A3A 0%,#1A1A1A 52%,#000 100%)"},
    {id:"sunset", name:"Sunset Terrace", cat:"Stadium", css:"radial-gradient(100% 60% at 50% 88%, rgba(255,140,40,.6), transparent 62%), linear-gradient(178deg,#1B1338 0%,#4A2050 48%,#8A3A22 100%)"},
    {id:"pitch", name:"Pitch Side", cat:"Photo", css:"radial-gradient(120% 55% at 50% 92%, rgba(40,140,60,.7), transparent 64%), linear-gradient(174deg,#0A1A10 0%,#123A1E 60%,#061008 100%)"},
    {id:"beast", name:"Beast Mode", cat:"Photo", css:"radial-gradient(85% 55% at 62% 40%, rgba(180,130,70,.55), transparent 58%), radial-gradient(110% 80% at 20% 15%, rgba(30,40,50,.7), transparent 60%), linear-gradient(160deg,#2A2018 0%,#14100C 55%,#050403 100%)"},
    {id:"ice", name:"Ice", cat:"Colour", css:"radial-gradient(110% 80% at 35% 18%, rgba(190,240,255,.55), transparent 58%), linear-gradient(160deg,#2A6E8E 0%,#12384C 55%,#050F16 100%)"},
    {id:"crimson-n", name:"Crimson Night", cat:"Grunge", css:"radial-gradient(90% 60% at 70% 30%, rgba(255,40,40,.42), transparent 58%), linear-gradient(168deg,#1A0206 0%,#450810 55%,#0A0102 100%)"}
  ],
  awards: [
    {id:"potm",  label:"Player of the Month",  a:"PLAYER",   c:"OF THE", b:"MONTH"},
    {id:"potma", label:"Player of the Match",  a:"PLAYER",   c:"OF THE", b:"MATCH"},
    {id:"pots",  label:"Player of the Season", a:"PLAYER",   c:"OF THE", b:"SEASON"},
    {id:"mgr",   label:"Manager's Player",     a:"MANAGER'S",c:"",       b:"PLAYER"},
    {id:"pp",    label:"Players' Player",      a:"PLAYERS'", c:"",       b:"PLAYER"},
    {id:"top",   label:"Top Goalscorer",       a:"TOP",      c:"",       b:"GOALSCORER"},
    {id:"imp",   label:"Most Improved",        a:"MOST",     c:"",       b:"IMPROVED"},
    {id:"club",  label:"Clubman of the Year",  a:"CLUBMAN",  c:"OF THE", b:"YEAR"},
    {id:"custom",label:"Something else…",      a:"",         c:"",       b:""}
  ],
  months: ["—","January","February","March","April","May","June","July",
           "August","September","October","November","December",
           "Full Season","Cup Final","Tournament"],
  fonts: [
    {id:"anton",   name:"Anton",         stack:"'Anton',sans-serif"},
    {id:"bangers", name:"Bangers",       stack:"'Bangers',cursive"},
    {id:"leaguesp",name:"League Spartan", stack:"'League Spartan',sans-serif"},
    {id:"passion", name:"Passion One",   stack:"'Passion One',sans-serif"},
    {id:"oswald",  name:"Oswald",        stack:"'Oswald',sans-serif"},
    {id:"staat",   name:"Staatliches",   stack:"'Staatliches',cursive"},
    {id:"bigsh",   name:"Big Shoulders", stack:"'Big Shoulders Display',sans-serif"},
    {id:"bungee",  name:"Bungee",        stack:"'Bungee',cursive"},
    {id:"cabinet", name:"Cabinet Grotesk",stack:"'Cabinet Grotesk',sans-serif"},
    {id:"ranade",  name:"Ranade",        stack:"'Ranade',serif"},
    {id:"chillax", name:"Chillax",       stack:"'Chillax',sans-serif"},
    {id:"archivonarrow",name:"Archivo Narrow",stack:"'Archivo Narrow',sans-serif"},
    {id:"humane",  name:"Humane",        stack:"'Humane','Oswald',sans-serif"},
    {id:"nohemi",  name:"Nohemi",        stack:"'Nohemi',sans-serif"},
    {id:"thunder", name:"Thunder",       stack:"'Thunder','Oswald',sans-serif"},
    {id:"blackops",name:"Black Ops One", stack:"'Black Ops One',sans-serif"},
    {id:"rubikdist",name:"Rubik Distressed",stack:"'Rubik Distressed',sans-serif"},
    {id:"rubikspray",name:"Rubik Spray Paint",stack:"'Rubik Spray Paint',sans-serif"},
    {id:"rubikglitch",name:"Rubik Glitch",stack:"'Rubik Glitch',sans-serif"},
    {id:"special", name:"Special Elite", stack:"'Special Elite',serif"},
    {id:"tradewinds",name:"Trade Winds", stack:"'Trade Winds',cursive"}
  ],
  colours: [
    {id:"white", hex:"#FFFFFF"},{id:"black", hex:"#0A0A0A"},
    {id:"gold",  hex:"#F0B62C"},{id:"red",   hex:"#FF0000"},
    {id:"blue",  hex:"#0008FF"},{id:"green", hex:"#009912"}
  ],
  layouts: [{id:"cresttop",name:"Crest Top"},{id:"titletop",name:"Title Top"},{id:"dynamic",name:"Dynamic"}]
};

/* ---------------- MERGE injected metaobject data ---------------- */
var INJ = (function(){
  try{ var el = document.getElementById("awb-data"); return el ? JSON.parse(el.textContent) : null; }
  catch(e){ return null; }
})();
function pick(key){ return (INJ && INJ[key] && INJ[key].length) ? INJ[key] : SEED[key]; }

// each award type -> its product's variants (size + pack + price), from #awb-products
var PRODUCTS = (function(){
  try{ var el = document.getElementById("awb-products"); return el ? JSON.parse(el.textContent) : {}; }
  catch(e){ return {}; }
})();
function packMatch(pack, kind){
  pack = (pack || "").toLowerCase();
  if(kind === "single") return pack === "" || pack.indexOf("single") > -1;
  if(kind === "season") return pack.indexOf("8 pack") > -1 || pack.indexOf("9 pack") > -1 || pack.indexOf("season") > -1;
  if(kind === "year")   return pack.indexOf("12 pack") > -1 || pack.indexOf("full year") > -1;
  return false;
}
function prodHasPack(prod, kind){
  return !!(prod && prod.variants && prod.variants.some(function(v){ return packMatch(v.pack, kind); }));
}

var BACKGROUNDS = pick("backgrounds");
var AWARDS      = pick("awards");
var MONTHS      = pick("months");
var FONTS       = pick("fonts");
var COLOURS     = pick("colours");
var LAYOUTS     = pick("layouts");

// a background may carry a real image url (metaobject) or a css gradient (seed)
function bgStyle(b){ return b.image ? "url('" + b.image + "')" : b.css; }
function bgById(id){ for(var i=0;i<BACKGROUNDS.length;i++){ if(BACKGROUNDS[i].id===id) return BACKGROUNDS[i]; } return null; }

/* ---------------- STATE ---------------- */
var S = {
  bg:null, award:AWARDS[0] ? AWARDS[0].id : "potm", c1:"", c2:"", cc:"",
  club:"", playerName:"", month:"April", season:"Season 26/27",
  crest:null, crestSize:32, crestX:0, crestY:0, crestFree:false, crestFront:false, vpos:"center", order:null, sponsorOn:false, sponsor:null, sponsor2:null, sponsorSize:1,
  font:FONTS[0] ? FONTS[0].id : "anton",
  colTitle:"#FFFFFF", colClub:"#FFFFFF", colName:"#FFFFFF", colMonth:"#FFFFFF", colSeason:"#F0B62C",
  outTitle:false, outClub:false, outName:false, outMonth:false, outSeason:false,
  outColTitle:"#0A0A0A", outColClub:"#0A0A0A", outColName:"#0A0A0A", outColMonth:"#0A0A0A", outColSeason:"#0A0A0A",
  owTitle:1, owClub:1, owName:1, owMonth:1, owSeason:1,
  shadowOn:false,
  szTitle:1, szClub:1, szName:1, szMonth:1, szSeason:1,
  layout:"cresttop",
  bundle:"single", rangeStart:"September", rangeEnd:"May", previewMonth:"September",
  namesRaw:"", names:[], previewName:"",
  awardType:"block", size:"", qty:1,
  showClub:true, showName:false, showMonth:true, showSeason:true, showCrest:true
};
var AWARDTYPE_LABEL = { block:"Crystal Block", plaque:"MDF Plaque", shield:"Award Shield" };

/* ---------------- BUILD UI ---------------- */
// background filters + grid
var cats = ["All"]; BACKGROUNDS.forEach(function(b){ if(b.cat && cats.indexOf(b.cat)<0) cats.push(b.cat); });
var animals = []; BACKGROUNDS.forEach(function(b){ if(b.animal && animals.indexOf(b.animal)<0) animals.push(b.animal); });
var activeCat = "All";
var bgPage = 0;
var BG_PER_PAGE = 9; // keep the grid 3 rows tall so it doesn't shove step 2 down the page
// colour chips first, then animal chips (matched on either dimension)
cats.forEach(function(c){ addBgChip(c, false); });
animals.forEach(function(a){ addBgChip(a, true); });
function addBgChip(label, isAnimal){
  var b = document.createElement("button");
  b.className = isAnimal ? "chip chip-animal" : "chip";
  b.type="button"; b.textContent=label;
  b.setAttribute("aria-pressed", String(label===activeCat));
  b.addEventListener("click", function(){
    activeCat=label; bgPage=0; // new filter -> back to first page
    Array.prototype.forEach.call($("bgfilter").children,function(x){
      x.setAttribute("aria-pressed", String(x.textContent===label)); });
    drawBgGrid();
  });
  $("bgfilter").appendChild(b);
}
function bgList(){ return BACKGROUNDS.filter(function(b){ return activeCat==="All"||b.cat===activeCat||b.animal===activeCat; }); }
function drawBgGrid(){
  var g=$("bggrid"); g.innerHTML="";
  var list = bgList();
  var pages = Math.max(1, Math.ceil(list.length / BG_PER_PAGE));
  if(bgPage >= pages) bgPage = pages - 1;
  var start = bgPage * BG_PER_PAGE;
  list.slice(start, start + BG_PER_PAGE).forEach(function(b){
    var el=document.createElement("button");
    el.className="bgcell"; el.type="button";
    el.setAttribute("aria-pressed", String(S.bg===b.id));
    var cellBg = b.thumb ? "url('"+b.thumb+"')" : bgStyle(b);
    el.innerHTML='<span class="bgc-in" style="background-image:'+cellBg+'"></span><span class="bgc-nm">'+b.name+'</span>';
    el.addEventListener("click", function(){ S.bg=b.id; drawBgGrid(); render(); });
    g.appendChild(el);
  });
  drawBgPager(list.length, pages, start);
}
function drawBgPager(total, pages, start){
  var p=$("bgpager"); if(!p) return;
  p.innerHTML="";
  if(pages <= 1){ p.hidden = true; return; }
  p.hidden = false;
  var prev=document.createElement("button");
  prev.type="button"; prev.className="awb-pgbtn"; prev.innerHTML="&lsaquo; Prev";
  prev.disabled = (bgPage === 0);
  prev.addEventListener("click", function(){ if(bgPage>0){ bgPage--; drawBgGrid(); } });
  var info=document.createElement("span");
  info.className="awb-pginfo";
  info.textContent = (start+1) + "–" + Math.min(total, start+BG_PER_PAGE) + " of " + total;
  var next=document.createElement("button");
  next.type="button"; next.className="awb-pgbtn"; next.innerHTML="Next &rsaquo;";
  next.disabled = (bgPage >= pages-1);
  next.addEventListener("click", function(){ if(bgPage<pages-1){ bgPage++; drawBgGrid(); } });
  p.appendChild(prev); p.appendChild(info); p.appendChild(next);
}
drawBgGrid();

// award select
AWARDS.forEach(function(a){
  var o=document.createElement("option"); o.value=a.id; o.textContent=a.label; $("i-award").appendChild(o);
});
MONTHS.forEach(function(m){
  var o=document.createElement("option"); o.value=m; o.textContent=m;
  if(m==="April") o.selected=true; $("i-month").appendChild(o);
});

// fonts — a compact dropdown (keeps the colour/size controls higher up the page)
var fontSel = $("fontsel");
if(fontSel){
  FONTS.forEach(function(f){
    var o=document.createElement("option");
    o.value=f.id; o.textContent=f.name;
    o.style.fontFamily=f.stack; // browsers that honour it show a live preview per option
    if(S.font===f.id) o.selected=true;
    fontSel.appendChild(o);
  });
  fontSel.addEventListener("change", function(){ S.font=this.value; render(); });
}

// colour swatches
function buildSw(host, key){
  COLOURS.forEach(function(c){
    var b=document.createElement("button");
    b.className="sw"; b.type="button"; b.style.background=c.hex;
    b.title=c.id; b.setAttribute("aria-label","Colour "+c.id);
    b.setAttribute("aria-pressed", String(S[key]===c.hex));
    b.addEventListener("click", function(){ S[key]=c.hex; syncSw(host,key); render(); });
    host.appendChild(b);
  });
  var wrap=document.createElement("button");
  wrap.className="sw sw-custom"; wrap.type="button"; wrap.title="Custom colour";
  wrap.setAttribute("aria-label","Custom colour");
  var inp=document.createElement("input"); inp.type="color"; inp.value=S[key];
  inp.addEventListener("input", function(){ S[key]=inp.value; syncSw(host,key); render(); });
  wrap.appendChild(inp); host.appendChild(wrap);
}
function syncSw(host,key){
  Array.prototype.forEach.call(host.children,function(x,i){
    x.setAttribute("aria-pressed", String(i<COLOURS.length && COLOURS[i].hex===S[key]));
  });
}
/* per-element colour + outline rows (award title / club / month / season) */
var LS = [
  {label:"Award title", col:"colTitle",  out:"outTitle",  outCol:"outColTitle",  ow:"owTitle"},
  {label:"Club name",   col:"colClub",   out:"outClub",   outCol:"outColClub",   ow:"owClub"},
  {label:"Player name", col:"colName",   out:"outName",   outCol:"outColName",   ow:"owName"},
  {label:"Month",       col:"colMonth",  out:"outMonth",  outCol:"outColMonth",  ow:"owMonth"},
  {label:"Season",      col:"colSeason", out:"outSeason", outCol:"outColSeason", ow:"owSeason"}
];
LS.forEach(function(item){
  var row = document.createElement("div"); row.className = "awb-lsrow";
  var lab = document.createElement("span"); lab.className = "awb-ls-label"; lab.textContent = item.label; row.appendChild(lab);
  var sw = document.createElement("div"); sw.className = "swatches awb-ls-sw"; row.appendChild(sw);
  buildSw(sw, item.col);
  var ow = document.createElement("span"); ow.className = "awb-ls-outwrap";
  ow.appendChild(document.createTextNode("Outline"));
  var ob = document.createElement("button"); ob.className = "switch switch-sm"; ob.type = "button";
  ob.setAttribute("aria-pressed", String(S[item.out])); ob.setAttribute("aria-label", "Outline " + item.label);
  ow.appendChild(ob); row.appendChild(ow);

  // outline colour + thickness — only visible while the outline is switched on (no wasted space otherwise)
  var octl = document.createElement("div"); octl.className = "awb-outctl"; octl.hidden = !S[item.out];
  var ocLab = document.createElement("span"); ocLab.className = "awb-outctl-lab"; ocLab.textContent = "Outline colour"; octl.appendChild(ocLab);
  var osw = document.createElement("div"); osw.className = "swatches awb-outsw"; octl.appendChild(osw);
  buildSw(osw, item.outCol);
  var owLab = document.createElement("span"); owLab.className = "awb-outctl-lab"; owLab.textContent = "Thickness"; octl.appendChild(owLab);
  var wr = document.createElement("input"); wr.type = "range"; wr.className = "range awb-outw";
  wr.min = "0.5"; wr.max = "3"; wr.step = "0.25"; wr.value = String(S[item.ow]);
  wr.setAttribute("aria-label", item.label + " outline thickness");
  wr.addEventListener("input", function(){ S[item.ow] = parseFloat(this.value); render(); });
  octl.appendChild(wr);

  ob.addEventListener("click", function(){ S[item.out] = !S[item.out]; ob.setAttribute("aria-pressed", String(S[item.out])); octl.hidden = !S[item.out]; render(); });

  row.appendChild(octl);
  $("letterStyle").appendChild(row);
});

/* per-element text size sliders. The award title is resizable (its position stays fixed by the
   layout); it gets a slightly smaller minimum so a tall 3-line title can be shrunk to fit. */
[{label:"Award title",key:"szTitle",min:"0.45"},{label:"Club name",key:"szClub"},{label:"Player name",key:"szName"},{label:"Month",key:"szMonth"},{label:"Season",key:"szSeason"}].forEach(function(item){
  var row = document.createElement("div"); row.className = "awb-szrow";
  var lab = document.createElement("span"); lab.className = "awb-ls-label"; lab.textContent = item.label; row.appendChild(lab);
  var rng = document.createElement("input"); rng.type = "range"; rng.className = "range awb-szrange";
  rng.min = item.min || "0.6"; rng.max = item.max || "1.5"; rng.step = "0.05"; rng.value = String(S[item.key]);
  rng.setAttribute("aria-label", item.label + " size");
  rng.addEventListener("input", function(){ S[item.key] = parseFloat(this.value); render(); });
  row.appendChild(rng);
  $("textSizes").appendChild(row);
});

// layout chips
LAYOUTS.forEach(function(l){
  var b=document.createElement("button");
  b.className="chip"; b.type="button"; b.textContent=l.name;
  b.setAttribute("aria-pressed", String(S.layout===l.id));
  b.addEventListener("click", function(){
    S.layout=l.id;
    S.order=null;   // picking a preset resets any custom section order
    Array.prototype.forEach.call($("layoutPick").children,function(x,i){
      x.setAttribute("aria-pressed", String(LAYOUTS[i].id===l.id)); });
    render();
  });
  $("layoutPick").appendChild(b);
});

/* ---------------- section reordering (up/down arrows) ---------------- */
var ORDER_EL    = { crest:"crest", title:"lockup", club:"clubLine", name:"nameLine", month:"monthLine", season:"seasonLine", sponsor:"sponsor" };
var ORDER_LABEL = { crest:"Crest", title:"Award title", club:"Club", name:"Player name", month:"Month", season:"Season", sponsor:"Sponsor" };
var ORDER_ALL   = ["crest","title","club","name","month","season","sponsor"];
function orderVisible(k){
  if(k === "crest")   return !!S.showCrest;
  if(k === "title")   return true;
  if(k === "club")    return !!S.showClub;
  if(k === "name")    return !!(S.showName && $("nameLine"));
  if(k === "month")   return !!S.showMonth;
  if(k === "season")  return !!S.showSeason;
  if(k === "sponsor") return !!(S.sponsorOn && (S.sponsor || S.sponsor2));
  return false;
}
function currentOrderFromDom(){
  var lay = $("layout"), arr = [], rev = {};
  for(var k in ORDER_EL){ rev["awb-" + ORDER_EL[k]] = k; }
  Array.prototype.forEach.call(lay.children, function(ch){ if(rev[ch.id]) arr.push(rev[ch.id]); });
  ORDER_ALL.forEach(function(k){ if(arr.indexOf(k) < 0) arr.push(k); });   // ensure all keys present
  return arr;
}
function moveSection(key, dir){
  if(!S.order) S.order = currentOrderFromDom();
  var vis = S.order.filter(orderVisible);
  var i = vis.indexOf(key); if(i < 0) return;
  var j = dir === "up" ? i - 1 : i + 1;
  if(j < 0 || j >= vis.length) return;
  var t = vis[i]; vis[i] = vis[j]; vis[j] = t;
  S.order = vis.concat(S.order.filter(function(k){ return !orderVisible(k); }));  // hidden keys parked at the end
  render();
}
function buildOrderControl(){
  var host = $("orderList"); if(!host) return;
  var order = (S.order && S.order.length) ? S.order : currentOrderFromDom();
  var vis = order.filter(orderVisible), html = "";
  vis.forEach(function(k, i){
    html += '<div class="awb-orow"><span class="awb-orow-l">' + ORDER_LABEL[k] + '</span><span class="awb-oarrows">' +
      '<button type="button" class="awb-oarrow" data-move="up" data-key="' + k + '"' + (i === 0 ? ' disabled' : '') + ' aria-label="Move ' + ORDER_LABEL[k] + ' up">&#9650;</button>' +
      '<button type="button" class="awb-oarrow" data-move="down" data-key="' + k + '"' + (i === vis.length - 1 ? ' disabled' : '') + ' aria-label="Move ' + ORDER_LABEL[k] + ' down">&#9660;</button>' +
      '</span></div>';
  });
  host.innerHTML = html;
  if($("orderReset")) $("orderReset").hidden = !(S.order && S.order.length);
}
if($("orderList")){
  $("orderList").addEventListener("click", function(e){
    var b = e.target.closest("[data-move]"); if(!b || b.disabled) return;
    moveSection(b.getAttribute("data-key"), b.getAttribute("data-move"));
  });
}
if($("orderReset")) $("orderReset").addEventListener("click", function(){ S.order = null; render(); });

// vertical position chips (Top / Centre / Spread) — fixes top-heavy designs
if($("vposPick")){
  Array.prototype.forEach.call($("vposPick").querySelectorAll("[data-vpos]"), function(btn){
    btn.addEventListener("click", function(){
      S.vpos = btn.getAttribute("data-vpos");
      Array.prototype.forEach.call($("vposPick").querySelectorAll("[data-vpos]"), function(x){
        x.setAttribute("aria-pressed", String(x.getAttribute("data-vpos") === S.vpos)); });
      render();
    });
  });
}

/* ---------------- award type (block / plaque / shield) ---------------- */
function isShield(){ return S.awardType === "shield"; }
function applyAwardType(){
  populateSizes();
  var prod = PRODUCTS[S.awardType];
  var hasSeason = prodHasPack(prod, "season");
  var hasYear   = prodHasPack(prod, "year");
  // shields are singles only; otherwise show bundles only if the product has packs
  var showBundles = !isShield() && (hasSeason || hasYear);
  $("bundlebar").hidden = !showBundles;
  var sel = $("bundleSelect");
  var seasonOpt = sel && sel.querySelector('option[value="season"]');
  var yearOpt   = sel && sel.querySelector('option[value="year"]');
  if(seasonOpt) seasonOpt.hidden = !hasSeason;
  if(yearOpt)   yearOpt.hidden   = !hasYear;
  // arrangement picker lives in the stage now; shields are always crest-first so hide it for them
  var layoutPick = $("stageLayout");
  if(layoutPick) layoutPick.hidden = isShield();
  if(!showBundles && S.bundle !== "single"){
    S.bundle = "single";
    if(sel) sel.value = "single";
    $("bundleCustom").hidden = true;
    $("monthField").hidden = false;
    if($("i-month")) $("i-month").hidden = false;
  }
  if(root.__awbFreeRefresh) root.__awbFreeRefresh();   // update the month/name lock state
}
$("size").addEventListener("change", function(){ S.size = this.value; render(); });
Array.prototype.forEach.call(root.querySelectorAll("[data-type]"), function(btn){
  btn.addEventListener("click", function(){
    S.awardType = btn.getAttribute("data-type");
    root.classList.remove("awb-notype");
    var _hi=$("typeheroimg"),_ti=btn.querySelector(".awb-type-img"); if(_hi&&_ti){ _hi.src=_ti.src; }
    Array.prototype.forEach.call(root.querySelectorAll("[data-type]"), function(b){
      b.classList.toggle("is-active", b === btn);
    });
    applyAwardType();
    render();
  });
});

/* ---------------- bundles ---------------- */
var CAL = ["January","February","March","April","May","June","July","August","September","October","November","December"];
var BUNDLE_LABEL = { single:"Single award", season:"8-month season", year:"12-month set", custom:"Custom range", names:"Personalised name awards" };
function rangeMonths(startName, endName){
  var s = CAL.indexOf(startName), e = CAL.indexOf(endName);
  if(s < 0 || e < 0) return [];
  var out = [], i = s, guard = 0;
  while(guard++ < 13){ out.push(CAL[i]); if(i === e) break; i = (i+1) % 12; }
  return out;
}
function bundleMonths(){
  if(S.bundle === "single") return (S.month && S.month !== "—") ? [S.month] : [];
  if(S.bundle === "season") return rangeMonths("October", "May");   // 8-award season (Sept has passed)
  if(S.bundle === "year")   return rangeMonths("January", "December");
  if(S.bundle === "custom") return rangeMonths(S.rangeStart, S.rangeEnd);
  return [];
}
function resetPreviewMonth(){
  var ms = bundleMonths();
  if(ms.indexOf(S.previewMonth) < 0) S.previewMonth = ms[0] || S.month;
}

// range dropdowns (calendar months)
CAL.forEach(function(mn){
  ["rangeStart","rangeEnd"].forEach(function(id){
    var o = document.createElement("option"); o.value = mn; o.textContent = mn; $(id).appendChild(o);
  });
});
$("rangeStart").value = S.rangeStart; $("rangeEnd").value = S.rangeEnd;
$("rangeStart").addEventListener("change", function(){ S.rangeStart = this.value; resetPreviewMonth(); render(); });
$("rangeEnd").addEventListener("change", function(){ S.rangeEnd = this.value; resetPreviewMonth(); render(); });

// bundle choice — dropdown ("This design is for")
if($("bundleSelect")){
  $("bundleSelect").addEventListener("change", function(){
    S.bundle = this.value;
    $("bundleCustom").hidden = (S.bundle !== "custom");
    // keep the month on/off toggle available on every bundle; only the month *picker*
    // hides on packs (the month is chosen per-award via the preview strip there)
    $("monthField").hidden = (S.bundle === "names");
    if($("i-month")) $("i-month").hidden = (S.bundle !== "single");
    if($("namesPanel")) $("namesPanel").hidden = (S.bundle !== "names");
    if(S.bundle !== "single") S.qty = 1; // multi-month sets are priced per month, not per copy
    if(S.bundle === "names") refreshNames();
    resetPreviewMonth();
    render();
    if(root.__awbFreeRefresh) root.__awbFreeRefresh();   // update the month/name lock state
  });
}

// ---- team pack: a list of player names -> one award per name ----
function parseNames(raw){
  return (raw || "").split(/[\r\n,;]+/).map(function(s){ return s.trim(); }).filter(function(s){ return s.length; });
}
function bundleCount(){ return (S.bundle === "names") ? S.names.length : bundleMonths().length; }
function refreshNames(){
  S.names = parseNames(S.namesRaw);
  if(S.names.length){ if(S.names.indexOf(S.previewName) < 0) S.previewName = S.names[0]; }
  else S.previewName = "";
  var cnt = $("namescount");
  if(cnt) cnt.textContent = S.names.length + (S.names.length === 1 ? " name" : " names");
}
if($("i-names")) $("i-names").addEventListener("input", function(){ S.namesRaw = this.value; refreshNames(); render(); });
if($("i-namescsv")) $("i-namescsv").addEventListener("change", function(){
  var f = this.files && this.files[0]; if(!f) return;
  var rd = new FileReader();
  rd.onload = function(){
    var rows = String(rd.result).split(/\r?\n/);
    var vals = rows.map(function(r){ return (r.split(",")[0] || "").trim(); }).filter(Boolean);
    if(vals.length && /^(name|player|player name)$/i.test(vals[0])) vals.shift();
    S.namesRaw = vals.join("\n");
    if($("i-names")) $("i-names").value = S.namesRaw;
    refreshNames(); render();
  };
  rd.readAsText(f);
  this.value = "";
});

// quantity stepper — order several copies of a single-award design
function setQty(n){
  S.qty = Math.max(1, Math.min(99, n));
  var v = $("qtyval"); if(v) v.textContent = S.qty;
  render();
}
function syncQtyRow(){
  var row = $("qtyrow"); if(!row) return;
  row.hidden = (S.bundle !== "single"); // multi-month sets already order one per month
  var v = $("qtyval"); if(v) v.textContent = S.qty;
}
if($("qtyminus")) $("qtyminus").addEventListener("click", function(){ setQty(S.qty - 1); });
if($("qtyplus"))  $("qtyplus").addEventListener("click",  function(){ setQty(S.qty + 1); });

// month strip under the preview (scrub to check each month fits)
var _lastStrip = "";
function updateMonthStrip(){
  var strip = $("monthstrip"), hint = $("stripHint");
  var isNames = (S.bundle === "names");
  var items = isNames ? S.names : bundleMonths();
  var show = (S.bundle !== "single") && items.length > 0;
  strip.hidden = !show; hint.hidden = !show;
  if(hint) hint.textContent = isNames
    ? "Tap a name to preview it — every award uses this one design."
    : "Tap a month to preview it — the whole set uses this one design.";
  if(!show){ _lastStrip = ""; return; }
  var sig = (isNames ? "N:" : "M:") + items.join(",");
  if(sig !== _lastStrip){
    strip.innerHTML = "";
    items.forEach(function(it){
      var b = document.createElement("button");
      b.type = "button"; b.className = "awb-monthtile"; b.title = it;
      b.textContent = isNames ? it.split(" ")[0] : it.slice(0,3).toUpperCase();
      b.addEventListener("click", function(){ if(isNames){ S.previewName = it; if(root.__awbTokens) root.__awbTokens.nameSet(it); } else { S.previewMonth = it; if(root.__awbTokens) root.__awbTokens.monthSet(it); } render(); });
      strip.appendChild(b);
    });
    _lastStrip = sig;
  }
  var cur = isNames ? S.previewName : S.previewMonth;
  Array.prototype.forEach.call(strip.children, function(b, i){
    b.setAttribute("aria-pressed", String(items[i] === cur));
  });
}

/* ---------------- accordion (mobile) / all-open (desktop) ---------------- */
var toggles = root.querySelectorAll("[data-toggle]");
function isDesktop(){ return window.matchMedia("(min-width:1000px)").matches; }
function applyLayoutMode(){
  root.classList.toggle("awb-desktop", isDesktop());
  // The wizard shows one step at a time, so panels are always fully open (no accordion).
  Array.prototype.forEach.call(toggles, function(btn){
    var step = btn.parentNode, body = step.querySelector(".step-body");
    if(body) body.hidden = false;
    step.setAttribute("open-panel","");
  });
}
applyLayoutMode();
window.addEventListener("resize", function(){ applyLayoutMode(); fitLockup(); });
var _mq = window.matchMedia("(min-width:1000px)");
if(_mq.addEventListener) _mq.addEventListener("change", function(){ applyLayoutMode(); fitLockup(); });
window.addEventListener("load", function(){ applyLayoutMode(); fitLockup(); });

/* ---------------- inputs ---------------- */
$("i-award").addEventListener("change", function(){
  S.award=this.value;
  $("customWrap").hidden = (S.award !== "custom");
  render();
});
["i-c1","i-c2","i-cc"].forEach(function(id){
  $(id).addEventListener("input", function(){
    S[{"i-c1":"c1","i-c2":"c2","i-cc":"cc"}[id]] = this.value; render();
  });
});
$("i-club").addEventListener("input", function(){ S.club=this.value; render(); });
if($("i-name")) $("i-name").addEventListener("input", function(){ S.playerName=this.value; render(); });
$("i-month").addEventListener("change", function(){ S.month=this.value; render(); });
$("i-season").addEventListener("input", function(){ S.season=this.value; render(); });
$("i-crestsize").addEventListener("input", function(){ S.crestSize=+this.value; render(); });

// ---- Drag the badge to reposition it. Guided: a centre guide, snap-to-centre and
// stay-in-frame clamping. Offsets are stored in cqw so they bake into the export
// (html2canvas) and travel through the proof URL, exactly like the crest size does.
(function initCrestDrag(){
  return;   // crest is now resize-only — its position is locked by the chosen layout (no dragging)
  var crest = $("crest"), award = $("award");
  if(!crest || !award) return;
  var guideV = document.createElement("div");
  guideV.className = "awb-cguide awb-cguide-v";
  award.appendChild(guideV);
  var drag = null;
  // allow travel in both cases: badge smaller than frame (edge reaches frame) OR bigger (frame stays covered)
  function clampX(x){ var m = Math.max(4, Math.abs(50 - S.crestSize/2)); return Math.max(-m, Math.min(m, x)); }
  function clampY(y){ var r = award.getBoundingClientRect(); var halfY = (r.height / (r.width||1)) * 50;
    var m = Math.max(4, Math.abs(halfY - S.crestSize/2)); return Math.max(-m, Math.min(m, y)); }
  crest.addEventListener("pointerdown", function(e){
    if(e.target === crest) return;              // ignore the empty band — only the badge itself
    if(S.showCrest === false) return;
    var r = award.getBoundingClientRect();
    drag = { px:e.clientX, py:e.clientY, ox:S.crestX||0, oy:S.crestY||0, w:r.width||340 };
    root.classList.add("awb-crestdrag");
    try{ crest.setPointerCapture(e.pointerId); }catch(_e){}
    e.preventDefault();
  });
  crest.addEventListener("pointermove", function(e){
    if(!drag) return;
    var nx = clampX(drag.ox + (e.clientX - drag.px) / drag.w * 100);
    var ny = clampY(drag.oy + (e.clientY - drag.py) / drag.w * 100);
    var snapped = false;
    if(Math.abs(nx) < 2.2){ nx = 0; snapped = true; }   // snap to horizontal centre
    if(Math.abs(ny) < 2.2){ ny = 0; }                   // snap back to home height
    S.crestX = nx; S.crestY = ny;
    crest.style.setProperty("--crest-x", nx + "cqw");
    crest.style.setProperty("--crest-y", ny + "cqw");
    guideV.classList.toggle("snap", snapped);
  });
  function endDrag(e){
    if(!drag) return;
    drag = null;
    root.classList.remove("awb-crestdrag");
    guideV.classList.remove("snap");
    try{ crest.releasePointerCapture(e.pointerId); }catch(_e){}
    render();   // sync the cart property, proof URL and the reset button
  }
  crest.addEventListener("pointerup", endDrag);
  crest.addEventListener("pointercancel", endDrag);
  if($("crestReset")) $("crestReset").addEventListener("click", function(){ S.crestX = 0; S.crestY = 0; render(); });
})();

function bindUpload(inputId, dropId, chipId, thumbId, nameId, removeId, key, cb){
  $(inputId).addEventListener("change", function(){
    var f=this.files&&this.files[0]; if(!f) return;
    var url=URL.createObjectURL(f);
    S[key]={name:f.name,url:url,file:f};
    $(thumbId).src=url; $(nameId).textContent=f.name;
    $(chipId).hidden=false; $(dropId).hidden=true;
    if(cb) cb(); render();
  });
  $(removeId).addEventListener("click", function(){
    if(S[key]) URL.revokeObjectURL(S[key].url);
    S[key]=null; $(inputId).value="";
    $(chipId).hidden=true; $(dropId).hidden=false;
    if(cb) cb(); render();
  });
}
bindUpload("i-crest","crestDrop","crestChip","crestThumb","crestName","crestRemove","crest", function(){ resetBgRow("crest"); });
bindUpload("i-sponsor","sponsorDrop","sponsorChip","sponsorThumb","sponsorName","sponsorRemove","sponsor", function(){ resetBgRow("sponsor"); });
if($("i-sponsor2")) bindUpload("i-sponsor2","sponsor2Drop","sponsor2Chip","sponsor2Thumb","sponsor2Name","sponsor2Remove","sponsor2", function(){ resetBgRow("sponsor2"); });

/* ---------------- background removal (tiers 1 & 2: transparency + edge flood-fill) ---------------- */
// The ORIGINAL file always goes to the order (the file input is never touched);
// this only cleans the on-screen preview, with a one-tap undo.
function resetBgRow(kind){
  var has = !!S[kind];
  $(kind+"BgRow").hidden = !has;
  $(kind+"BgBtn").hidden = false;
  $(kind+"BgUndo").hidden = true;
  $(kind+"BgMsg").textContent = "";
}

function removeBackground(imgEl, done){
  var W = imgEl.naturalWidth, H = imgEl.naturalHeight;
  if(!W || !H){ done(null, "unreadable"); return; }
  var scale = Math.min(1, 900 / Math.max(W, H));
  var w = Math.max(1, Math.round(W*scale)), h = Math.max(1, Math.round(H*scale));
  var c = document.createElement("canvas"); c.width = w; c.height = h;
  var ctx = c.getContext("2d");
  ctx.drawImage(imgEl, 0, 0, w, h);
  var id, d;
  try { id = ctx.getImageData(0,0,w,h); d = id.data; }
  catch(e){ done(null, "unreadable"); return; }

  // Tier 1 — already transparent?
  var trans = 0;
  for(var i = 3; i < d.length; i += 4){ if(d[i] < 250) trans++; }
  if(trans > w*h*0.02){ done(null, "already"); return; }

  // Tier 2 — do the four corners agree on a background colour?
  function at(x,y){ var o=(y*w+x)*4; return [d[o],d[o+1],d[o+2]]; }
  var corners = [at(0,0), at(w-1,0), at(0,h-1), at(w-1,h-1)];
  var avg = [0,0,0];
  corners.forEach(function(c2){ avg[0]+=c2[0]; avg[1]+=c2[1]; avg[2]+=c2[2]; });
  avg = [avg[0]/4, avg[1]/4, avg[2]/4];
  var agree = corners.every(function(c2){
    return Math.abs(c2[0]-avg[0])<32 && Math.abs(c2[1]-avg[1])<32 && Math.abs(c2[2]-avg[2])<32;
  });
  if(!agree){ done(null, "nocorner"); return; }

  // Flood-fill the background inward from every edge pixel (preserves interior detail).
  var tol = 48, visited = new Uint8Array(w*h), stack = [];
  for(var x=0; x<w; x++){ stack.push(x); stack.push((h-1)*w + x); }
  for(var y=0; y<h; y++){ stack.push(y*w); stack.push(y*w + (w-1)); }
  function matches(o){ return Math.abs(d[o]-avg[0])<tol && Math.abs(d[o+1]-avg[1])<tol && Math.abs(d[o+2]-avg[2])<tol; }
  while(stack.length){
    var idx = stack.pop();
    if(idx < 0 || idx >= w*h || visited[idx]) continue;
    visited[idx] = 1;
    var o = idx*4;
    if(!matches(o)) continue;
    d[o+3] = 0;
    var px = idx % w;
    if(px > 0)   stack.push(idx-1);
    if(px < w-1) stack.push(idx+1);
    stack.push(idx-w);
    stack.push(idx+w);
  }
  ctx.putImageData(id, 0, 0);
  done(c.toDataURL("image/png"), "flood");
}

function setupBgRemoval(kind){
  var btn = $(kind+"BgBtn"), undo = $(kind+"BgUndo"), msg = $(kind+"BgMsg");
  btn.addEventListener("click", function(){
    var st = S[kind]; if(!st) return;
    msg.textContent = "Working…";
    var img = new Image();
    img.onload = function(){
      removeBackground(img, function(dataUrl, how){
        if(how === "already"){ msg.textContent = "This image already has a see-through background."; }
        else if(how === "nocorner"){ msg.textContent = "No plain background found to remove — try a PNG, or crop it first."; }
        else if(how === "unreadable"){ msg.textContent = "Couldn't read that image type."; }
        else if(dataUrl){ st.processedUrl = dataUrl; undo.hidden = false; btn.hidden = true; msg.textContent = "Background removed (preview)."; render(); }
        else { msg.textContent = "No change made."; }
      });
    };
    img.onerror = function(){ msg.textContent = "Couldn't read that image."; };
    img.src = st.url; // always process from the original
  });
  undo.addEventListener("click", function(){
    var st = S[kind]; if(st) st.processedUrl = null;
    undo.hidden = true; btn.hidden = false; msg.textContent = ""; render();
  });
}
setupBgRemoval("crest");
setupBgRemoval("sponsor");
if($("sponsor2BgBtn")) setupBgRemoval("sponsor2");

function bindSwitch(id, key, after){
  $(id).addEventListener("click", function(){
    S[key]=!S[key];
    this.setAttribute("aria-pressed", String(S[key]));
    if(after) after(); render();
  });
}
bindSwitch("sw-sponsor","sponsorOn", function(){ $("sponsorWrap").hidden = !S.sponsorOn; });
if($("sw-shadow")) bindSwitch("sw-shadow","shadowOn");
(function(){ var sz = $("i-sponsorsize"); if(sz){ sz.addEventListener("input", function(){ S.sponsorSize = parseFloat(this.value); render(); }); } })();
// per-element show/hide toggles
bindSwitch("tg-club","showClub");
if($("tg-name")) bindSwitch("tg-name","showName");
bindSwitch("tg-month","showMonth");
bindSwitch("tg-season","showSeason");
bindSwitch("tg-crest","showCrest", function(){ $("crestControls").hidden = !S.showCrest; });
if($("sw-crestfree")) bindSwitch("sw-crestfree","crestFree", function(){ if($("crestFrontRow")) $("crestFrontRow").hidden = !S.crestFree; });
if($("sw-crestfront")) bindSwitch("sw-crestfront","crestFront");

/* ===== "Building your design" blocking overlay + progress (every build path) ===== */
var buildOverlay = (function(){
  var el, bar, msg;
  var guard = function(e){ e.preventDefault(); e.returnValue = ""; return ""; };
  function ensure(){
    if(el) return;
    el = document.createElement("div"); el.className = "awb-building";
    el.innerHTML =
      '<div class="awb-building-card" role="alertdialog" aria-live="assertive">' +
        '<div class="awb-building-spin"></div>' +
        '<p class="awb-building-msg">Building your design\u2026</p>' +
        '<div class="awb-building-track"><div class="awb-building-bar"></div></div>' +
        '<p class="awb-building-sub">Please keep this page open \u2014 don\u2019t press back or refresh while we build it.</p>' +
      '</div>';
    (root || document.body).appendChild(el);
    bar = el.querySelector(".awb-building-bar");
    msg = el.querySelector(".awb-building-msg");
  }
  return {
    show: function(m){ ensure(); if(m && msg) msg.textContent = m; el.classList.add("is-on"); el.classList.add("is-indeterminate"); if(bar) bar.style.width = "40%"; window.addEventListener("beforeunload", guard); },
    progress: function(i, n){ ensure(); el.classList.remove("is-indeterminate"); var pct = n > 0 ? ((i / n) * 100) : 0; if(bar) bar.style.width = Math.max(5, Math.round(pct)) + "%"; if(msg) msg.textContent = "Building your awards\u2026 " + Math.min(i + 1, n) + " of " + n; },
    done: function(){ ensure(); el.classList.remove("is-indeterminate"); if(bar) bar.style.width = "100%"; if(msg) msg.textContent = "Almost there\u2026"; },
    allowNav: function(){ window.removeEventListener("beforeunload", guard); },
    hide: function(){ window.removeEventListener("beforeunload", guard); if(el) el.classList.remove("is-on"); }
  };
})();

/* ---------------- "Prefer we finish it?" -> send the design to the team (no free download) ----------------
   Anti-abuse: the clean, print-ready artwork now only ever leaves via a PAID order. This button emails
   Tony the customer's contact + a proof LINK that rebuilds their exact design, so he can finish & quote it. */
(function(){
  var btn = $("finish"), modal = $("finishmodal");
  if(!btn || !modal) return;
  function spec(){
    var p = [];
    if(S.club) p.push("Club/team: " + S.club);
    p.push("Award: " + (AWARDTYPE_LABEL[S.awardType] || S.awardType || ""));
    if(S.showMonth && S.month) p.push("Month: " + S.month);
    if(S.season) p.push("Season: " + S.season);
    p.push("Bundle: " + (BUNDLE_LABEL[S.bundle] || S.bundle || "single"));
    return p.join(" · ");
  }
  function openModal(){
    if($("ff-proof")) $("ff-proof").value = $("p-proofurl") ? $("p-proofurl").value : "";
    if($("ff-spec"))  $("ff-spec").value  = spec();
    modal.hidden = false;
  }
  btn.addEventListener("click", openModal);
  Array.prototype.forEach.call(modal.querySelectorAll("[data-finishclose]"), function(x){
    x.addEventListener("click", function(){ modal.hidden = true; });
  });
  document.addEventListener("keydown", function(e){ if(e.key === "Escape" && !modal.hidden) modal.hidden = true; });

  var form = $("finishform");
  if(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var sb = $("finish-submit"), err = $("finish-err");
      var t = sb ? sb.textContent : "";
      if(sb){ sb.disabled = true; sb.textContent = "Sending…"; }
      if(err) err.hidden = true;
      fetch("https://api.web3forms.com/submit", {
        method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form)
      }).then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
        .then(function(r){
          if(r.ok && r.j && r.j.success){
            if($("finishform-wrap")) $("finishform-wrap").style.display = "none";
            if($("finish-success")) $("finish-success").hidden = false;
          } else { fail(); }
        }).catch(fail);
      function fail(){ if(sb){ sb.disabled = false; sb.textContent = t; } if(err) err.hidden = false; }
    });
  }
})();
// clip a captured canvas to the shield outline (html2canvas ignores clip-path)
function clipToShield(src){
  var c = document.createElement("canvas"); c.width = src.width; c.height = src.height;
  var ctx = c.getContext("2d"), w = src.width, h = src.height;
  ctx.beginPath();
  ctx.moveTo(0.24*w, 0);
  ctx.lineTo(0.76*w, 0);
  ctx.bezierCurveTo(0.88*w,0.01*h, 1.0*w,0.05*h, 1.0*w,0.15*h);
  ctx.bezierCurveTo(1.0*w,0.40*h, 0.90*w,0.62*h, 0.72*w,0.80*h);
  ctx.bezierCurveTo(0.63*w,0.89*h, 0.55*w,0.95*h, 0.50*w,1.0*h);
  ctx.bezierCurveTo(0.45*w,0.95*h, 0.37*w,0.89*h, 0.28*w,0.80*h);
  ctx.bezierCurveTo(0.10*w,0.62*h, 0,0.40*h, 0,0.15*h);
  ctx.bezierCurveTo(0,0.05*h, 0.12*w,0.01*h, 0.24*w,0);
  ctx.closePath(); ctx.clip();
  ctx.drawImage(src, 0, 0);
  return c;
}

/* ---------------- RENDER ---------------- */
function awardParts(){
  if(S.award==="custom") return {a:S.c1||"YOUR",c:S.cc,b:S.c2||"AWARD",label:"Custom"};
  var a=AWARDS.filter(function(x){return x.id===S.award;})[0] || AWARDS[0];
  return {a:a.a,c:a.c,b:a.b,label:a.label};
}

function render(){
  var bg = bgById(S.bg);
  $("bg").style.backgroundImage = bg ? bgStyle(bg) : "linear-gradient(160deg,#232827,#0E1211)";

  var font = FONTS.filter(function(f){ return f.id===S.font; })[0] || FONTS[0];
  var aw = $("award");
  aw.style.fontFamily = font.stack;
  aw.classList.toggle("is-shield", isShield());
  aw.style.setProperty("--sztitle", S.szTitle);
  aw.style.setProperty("--szclub", S.szClub);
  aw.style.setProperty("--szname", S.szName);
  aw.style.setProperty("--szmonth", S.szMonth);
  aw.style.setProperty("--szseason", S.szSeason);

  var effLayout = isShield() ? "crest-first" : S.layout;
  var lay = $("layout");
  lay.className = "layout " + effLayout;
  if(S.shadowOn) lay.classList.add("awb-shadow");
  if(S.crestFree) lay.classList.add("awb-crestfree");
  if(S.crestFront) lay.classList.add("awb-crest-front");
  // fixed layouts — vertical position control retired
  lay.style.setProperty("--crest-w", S.crestSize + "cqw");
  var crestEl = $("crest");
  if(crestEl){
    crestEl.style.setProperty("--crest-x", (S.crestX || 0) + "cqw");
    crestEl.style.setProperty("--crest-y", (S.crestY || 0) + "cqw");
  }
  if($("crestReset")) $("crestReset").hidden = !(S.crestX || S.crestY);

  var p = awardParts();
  $("lk1").textContent = p.a;
  $("lk2").textContent = p.b;
  $("lk1").hidden = !p.a;
  if(p.c){
    var w = p.c.split(" ");
    $("lkcon").innerHTML = w.map(function(x){ return "<span>"+x+"</span>"; }).join("");
    $("lkcon").hidden = false;
  } else { $("lkcon").hidden = true; }

  $("clubLine").hidden = !S.showClub;
  $("clubLine").textContent = S.club || "Your club name";
  $("clubLine").style.opacity = S.club ? 1 : .5;

  if($("nameLine")){
    var namesMode = (S.bundle === "names");
    var nameShown = namesMode ? true : S.showName;
    var nameVal   = namesMode ? S.previewName : S.playerName;
    $("nameLine").hidden = !nameShown;
    $("nameLine").textContent = nameVal || "Player name";
    $("nameLine").style.opacity = nameVal ? 1 : .5;
  }

  var displayMonth;
  if(S.bundle === "single"){ displayMonth = S.month; }
  else {
    var ms = bundleMonths();
    if(ms.indexOf(S.previewMonth) < 0) S.previewMonth = ms[0] || S.month;
    displayMonth = S.previewMonth;
  }
  $("monthLine").textContent = (displayMonth && displayMonth !== "—") ? displayMonth : "";
  $("monthLine").hidden = !S.showMonth || !displayMonth || displayMonth === "—" || S.bundle === "names";

  $("seasonLine").textContent = S.season;
  $("seasonLine").hidden = !S.showSeason || !S.season;

  applyLetterStyles();

  if(!S.showCrest){
    $("crest").hidden = true;
    $("crest").innerHTML = "";
  } else {
    $("crest").hidden = false;
    if(S.crest){
      $("crest").innerHTML = '<img src="'+(S.crest.processedUrl || S.crest.url)+'" alt="Club crest">';
    } else {
      $("crest").innerHTML = '<div class="crest-ph">Your crest here</div>';
    }
  }

  var _sp1 = S.sponsorOn && S.sponsor, _sp2 = S.sponsorOn && S.sponsor2;
  $("sponsor").hidden = !(_sp1 || _sp2);
  $("sponsorImg").hidden = !_sp1;
  if(_sp1) $("sponsorImg").src = (S.sponsor.processedUrl || S.sponsor.url);
  if($("sponsorImg2")){
    $("sponsorImg2").hidden = !_sp2;
    if(_sp2) $("sponsorImg2").src = (S.sponsor2.processedUrl || S.sponsor2.url);
  }
  $("sponsor").style.setProperty("--sp-w", (18 + (S.sponsorSize * 16)).toFixed(1) + "cqw");
  $("sponsor").style.setProperty("--sp-scale", S.sponsorSize);

  var _custom = !!(S.order && S.order.length);
  if(_custom){
    // customer's own section order (arrows) — DOM reorder so it bakes into the export
    S.order.forEach(function(k){ var el = $(ORDER_EL[k]); if(el) lay.appendChild(el); });
  } else if(effLayout === "crest-first" || effLayout === "cresttop"){
    // crest leads (shields + the Crest Top arrangement): crest, then club, then the title lockup
    lay.appendChild($("crest")); lay.insertBefore($("crest"), lay.firstChild);
    lay.insertBefore($("clubLine"), $("lockup"));
  } else {
    lay.insertBefore($("lockup"), lay.firstChild);
    lay.insertBefore($("clubLine"), $("crest"));
  }
  // player name: normally under the club line, but when the month is switched OFF it drops
  // below the badge to take the month's prominent place (a named award). Custom order overrides position.
  var _nl = $("nameLine");
  if(_nl){
    var nameInMonthSlot = (S.bundle === "names") || (!S.showMonth && S.showName);
    _nl.classList.toggle("in-month", nameInMonthSlot);
    if(!_custom){
      if(nameInMonthSlot) lay.insertBefore(_nl, $("monthLine"));
      else lay.insertBefore(_nl, $("clubLine").nextSibling);
    }
  }
  buildOrderControl();

  fitLockup();
  updateMonthStrip();
  syncQtyRow();
  updateSummary(p, bg, font);
  syncCartFields(p, bg);
}

// Mirror the design state into the hidden cart form fields (line item properties).
function syncCartFields(p, bg){
  if(!$("p-background")) return; // no form on page (e.g. standalone preview)
  var title = (p.label === "Custom") ? [p.a, p.c, p.b].filter(Boolean).join(" ") : p.label;
  $("p-background").value = bg ? bg.name : "";
  $("p-award").value      = title;
  $("p-club").value       = S.showClub ? S.club : "";
  if($("p-name")) $("p-name").value = (S.showName && S.playerName) ? S.playerName : "";
  $("p-month").value      = (S.showMonth && S.bundle === "single" && S.month !== "—") ? S.month : "";
  $("p-season").value     = S.showSeason ? S.season : "";
  $("i-crest").disabled   = !S.showCrest;
  $("p-bgid").value       = S.bg || "";
  $("p-font").value       = S.font;
  $("p-coltitle").value   = S.colTitle;
  $("p-colclub").value    = S.colClub;
  $("p-colmonth").value   = S.colMonth;
  $("p-colseason").value  = S.colSeason;
  var _outs = [];
  if(S.outTitle) _outs.push("Award title"); if(S.outClub) _outs.push("Club");
  if(S.outMonth) _outs.push("Month"); if(S.outSeason) _outs.push("Season");
  $("p-outline").value    = _outs.join(", ");
  if($("p-effects")){
    var _fx = [];
    if(S.shadowOn) _fx.push("Drop shadow");
    var _spn = (S.sponsor?1:0) + (S.sponsor2?1:0);
    if(S.sponsorOn && _spn) _fx.push(_spn + " sponsor" + (_spn>1?"s":"") + " (size " + Math.round(18 + S.sponsorSize*16) + "cqw)");
    var _oc = [];
    if(S.outTitle)  _oc.push("Title " + S.outColTitle + " x" + S.owTitle);
    if(S.outClub)   _oc.push("Club " + S.outColClub + " x" + S.owClub);
    if(S.outMonth)  _oc.push("Month " + S.outColMonth + " x" + S.owMonth);
    if(S.outSeason) _oc.push("Season " + S.outColSeason + " x" + S.owSeason);
    if(_oc.length) _fx.push("Outline " + _oc.join("; "));
    $("p-effects").value = _fx.join(" · ");
  }
  var _szs = [];
  if(S.szTitle !== 1)  _szs.push("Award title " + Math.round(S.szTitle * 100) + "%");
  if(S.szClub !== 1)   _szs.push("Club " + Math.round(S.szClub * 100) + "%");
  if(S.szMonth !== 1)  _szs.push("Month " + Math.round(S.szMonth * 100) + "%");
  if(S.szSeason !== 1) _szs.push("Season " + Math.round(S.szSeason * 100) + "%");
  $("p-textsizes").value  = _szs.join(", ");
  $("p-layout").value     = S.layout + (S.vpos && S.vpos !== "center" ? " (" + S.vpos + ")" : "") + (S.order && S.order.length ? " · custom order" : "");
  $("p-crestsize").value  = S.crestSize;
  if($("p-crestpos")){
    var _cp = (S.crestX || S.crestY) ? (Math.round(S.crestX) + "," + Math.round(S.crestY)) : "";
    if(S.crestFree)  _cp += (_cp ? " · " : "") + "overlap";
    if(S.crestFront) _cp += (_cp ? " · " : "") + "in front";
    $("p-crestpos").value = _cp;
  }
  var months = bundleMonths();
  $("p-awardtype").value   = AWARDTYPE_LABEL[S.awardType] || "";
  $("p-awardtypeid").value = S.awardType;
  $("p-bundle").value   = BUNDLE_LABEL[S.bundle] || "";
  $("p-bundleid").value = S.bundle;
  $("p-months").value   = months.join(",");
  if($("p-names")) $("p-names").value = (S.bundle === "names") ? S.names.join(", ") : "";
  selectVariant();
  buildProofUrl(p, bg, months);
}

// Encode the full spec into a URL on the proof page. The owner opens this one
// link on the order and the exact design rebuilds itself (crest loaded separately).
function buildProofUrl(p, bg, months){
  if(!$("p-proofurl")) return;
  var base = root.getAttribute("data-proof-url") || "";
  if(!base){ $("p-proofurl").value = ""; return; }
  if(base.charAt(0) === "/") base = window.location.origin + base; // make absolute for the admin
  var font = FONTS.filter(function(f){ return f.id === S.font; })[0] || FONTS[0];
  var params = {
    view:      "award-proof",
    bg:        bg ? bgStyle(bg) : "",
    a: p.a, c: p.c, b: p.b,
    club:      S.club,
    season:    S.season,
    months:    months.join(","),
    bundle:    S.bundle,
    font:      font.stack,
    ct: S.colTitle, cc: S.colClub, cm: S.colMonth, cs: S.colSeason,
    ot: S.outTitle ? "1" : "0", oc: S.outClub ? "1" : "0", om: S.outMonth ? "1" : "0", oe: S.outSeason ? "1" : "0",
    zt: S.szTitle, zc: S.szClub, zm: S.szMonth, zs: S.szSeason,
    layout:    S.layout,
    crestsize: S.crestSize,
    cx: Math.round(S.crestX || 0),
    cy: Math.round(S.crestY || 0),
    cfree:  S.crestFree ? "1" : "0",
    cfront: S.crestFront ? "1" : "0",
    vp: S.vpos || "center",
    ord: (S.order && S.order.length) ? S.order.join(",") : "",
    sponsor:   (S.sponsorOn && S.sponsor) ? "1" : "0",
    sc: S.showClub ? "1" : "0",
    sm: S.showMonth ? "1" : "0",
    ss: S.showSeason ? "1" : "0",
    scr: S.showCrest ? "1" : "0"
  };
  var qs = Object.keys(params).map(function(k){ return k + "=" + encodeURIComponent(params[k]); }).join("&");
  $("p-proofurl").value = base + (base.indexOf("?") > -1 ? "&" : "?") + qs;
}

// Fill the size dropdown from the selected award type's product.
function populateSizes(){
  var prod = PRODUCTS[S.awardType], sel = $("size");
  if(!sel) return;
  sel.innerHTML = "";
  var seen = {};
  (prod && prod.variants ? prod.variants : []).forEach(function(v){
    if(v.size == null || seen[v.size]) return; seen[v.size] = 1;
    var o = document.createElement("option"); o.value = v.size; o.textContent = v.size; sel.appendChild(o);
  });
  var values = Array.prototype.map.call(sel.options, function(o){ return o.value; });
  if(values.indexOf(S.size) < 0) S.size = values[0] || "";
  sel.value = S.size;
  var lab = $("sizeLabel");
  if(lab && prod && prod.sizeName) lab.textContent = prod.sizeName;
}

// Resolve the exact variant from (award type + size + bundle) and set price/qty.
// If a pack variant doesn't exist for the size, fall back to the single variant x
// number of months, so a bundle never adds at the single price.
function selectVariant(){
  var idEl = $("varid"), qtyEl = $("qty");
  if(!idEl) return; // no product on page (e.g. standalone preview)
  var prod = PRODUCTS[S.awardType];
  if(!prod || !prod.variants || !prod.variants.length) return;
  var vs = prod.variants, qty = 1, chosen = null;
  function bySize(kind){ return vs.filter(function(v){ return v.size === S.size && packMatch(v.pack, kind); })[0]; }
  if(S.bundle === "single"){
    chosen = bySize("single");
  } else if(S.bundle === "season" || S.bundle === "year"){
    chosen = bySize(S.bundle);
    if(!chosen){ chosen = bySize("single"); qty = Math.max(1, bundleMonths().length); }
  } else { // custom range or team-by-name
    chosen = bySize("single"); qty = Math.max(1, bundleCount());
  }
  if(!chosen) chosen = vs.filter(function(v){ return v.size === S.size; })[0] || vs[0];
  qty = qty * Math.max(1, S.qty); // customer can order several copies of the same design
  idEl.value = chosen.id;
  if(qtyEl) qtyEl.value = qty;
  var priceStr = (qty > 1) ? (chosen.priceText + " each × " + qty) : chosen.priceText;
  var pr = $("price"); if(pr) pr.textContent = priceStr;
  var pr2 = $("buyprice"); if(pr2) pr2.textContent = priceStr;
}

/* apply each element's own colour + outline */
function applyLetterStyles(){
  colourEls([$("lk1"), $("lk2"), $("lkcon")], S.colTitle, S.outTitle, S.outColTitle, S.owTitle);
  colourEls([$("clubLine")], S.colClub, S.outClub, S.outColClub, S.owClub);
  colourEls([$("nameLine")], S.colName, S.outName, S.outColName, S.owName);
  colourEls([$("monthLine")], S.colMonth, S.outMonth, S.outColMonth, S.owMonth);
  colourEls([$("seasonLine")], S.colSeason, S.outSeason, S.outColSeason, S.owSeason);
}
function outlineShadow(color, radius){
  // A ring of offset shadows fakes a text outline that the compositor (html2canvas) CAN bake in;
  // -webkit-text-stroke renders on screen but is dropped from the exported image.
  var n = 16, parts = [], i, a;
  for(i = 0; i < n; i++){
    a = (i / n) * 2 * Math.PI;
    parts.push((Math.cos(a) * radius).toFixed(3) + "cqw " + (Math.sin(a) * radius).toFixed(3) + "cqw 0 " + color);
  }
  return parts;
}
function colourEls(els, col, outline, outCol, outW){
  var radius = (outW || 1) * 0.38;                       // outline thickness (cqw)
  var shadows = [];
  if(outline) shadows = outlineShadow(outCol || strokeCol(col), radius);
  if(S.shadowOn) shadows.push("0 0.55cqw 1.1cqw rgba(0,0,0,.6)");  // "make it pop" soft shadow
  els.forEach(function(el){
    if(!el) return;
    el.style.color = col;
    el.style.webkitTextStrokeWidth = "0";                // stroke won't export; the shadow ring does
    el.style.textShadow = shadows.length ? shadows.join(", ") : "none";
  });
}
function strokeCol(col){ return isLightHex(col) ? "#0A0A0A" : "#FFFFFF"; }
function isLightHex(hex){
  hex = (hex || "").replace("#","");
  if(hex.length === 3) hex = hex.replace(/(.)/g, "$1$1");
  var r = parseInt(hex.substr(0,2),16), g = parseInt(hex.substr(2,2),16), b = parseInt(hex.substr(4,2),16);
  if(isNaN(r)) return false;
  return (0.299*r + 0.587*g + 0.114*b) > 150;
}

// Shrink the big title words so they never spill past the preview edges,
// whatever the font or word length (e.g. "GOALSCORER", "IMPROVED").
function fitLockup(){
  var lay = $("layout");
  var avail = lay.clientWidth - (lay.clientWidth * 0.10); // ~5cqw padding each side
  if(avail <= 0) return;
  fitOne($("lk1"), "--fit", avail);
  fitOne($("lk2"), "--fit", avail);
  fitOne($("clubLine"), "--fitclub", avail);
  fitOne($("nameLine"), "--fitname", avail);
  fitOne($("monthLine"), "--fitm", avail);
  fitOne($("seasonLine"), "--fitseason", avail);
}
// clamp an element so it never spills past the preview edges, whatever its size slider
function fitOne(el, v, avail){
  if(!el || el.hidden) return;
  el.style.setProperty(v, "1");
  var w = el.scrollWidth;
  if(w > avail) el.style.setProperty(v, (avail / w * 0.98).toFixed(3));
}

function updateSummary(p, bg, font){
  // Award details now covers the wording AND the crest (they live in one step)
  var checks = {
    award: (!S.showClub || !!S.club) && (!S.showCrest || !!S.crest),
    bg: !!S.bg, type: true, layout: true
  };
  var done = 0;
  Object.keys(checks).forEach(function(k){
    var step = root.querySelector('[data-step="'+k+'"]');
    if(step) step.classList.toggle("done", checks[k]);
    if(checks[k]) done++;
  });
  if($("progress")) $("progress").textContent = done + " of 4 complete";

  $("v-bg").textContent    = bg ? bg.name : "Not chosen";
  $("v-award").textContent = p.label;
  $("v-type").textContent  = font.name;
  if($("v-layout")) $("v-layout").textContent = (LAYOUTS.filter(function(l){return l.id===S.layout;})[0]||LAYOUTS[0]).name;

  var missing = [];
  if(!S.bg) missing.push("a background");
  $("warn").hidden = missing.length === 0;
  $("warn").textContent = missing.length ? "Still to add: " + missing.join(", ") + "." : "";
  $("approve").disabled = missing.length > 0;

  // clean key/value summary of the order (colours are shown live in the preview, not listed)
  var when = [];
  if(S.bundle === "single"){ if(S.showMonth && S.month !== "—") when.push(S.month); }
  else { var ms = bundleMonths(); if(ms.length) when.push(ms.length + " months"); }
  if(S.showSeason && S.season) when.push(S.season);
  var rows = [
    ["Item",       (AWARDTYPE_LABEL[S.awardType] || "") + (S.size ? " · " + S.size : "")],
    ["Award",      p.label],
    ["Club",       S.showClub ? (S.club || "—") : "—"],
    ["For",        when.length ? when.join(" · ") : "—"],
    ["Background",  bg ? bg.name : "—"],
    ["Font",       font.name],
    ["Layout",     (LAYOUTS.filter(function(l){return l.id===S.layout;})[0]||LAYOUTS[0]).name]
  ];
  $("spec").innerHTML = rows.map(function(r){
    return '<div class="spec-row"><span class="spec-k">' + r[0] + '</span><span class="spec-v">' + r[1] + '</span></div>';
  }).join("");
}

function awbEsc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }
// Confirm the personalised-name list & count before adding N awards to the basket.
function showNamesConfirm(onConfirm){
  var names = S.names.slice();
  var seen = {}, dups = {};
  names.forEach(function(nm){ var k = nm.toLowerCase(); if(seen[k]) dups[k] = true; seen[k] = true; });
  var dupCount = 0; for(var k in dups){ if(dups.hasOwnProperty(k)) dupCount++; }
  var priceTxt = $("price") ? $("price").textContent : "";
  var listHtml = names.map(function(nm){
    var d = dups[nm.toLowerCase()];
    return '<li' + (d ? ' class="is-dup"' : '') + '>' + awbEsc(nm) + (d ? ' <span class="awb-dup-tag">duplicate</span>' : '') + '</li>';
  }).join("");
  var plural = names.length === 1 ? "" : "s";
  var wrap = document.createElement("div"); wrap.className = "awb-modal";
  wrap.innerHTML =
    '<div class="awb-modal-scrim" data-cancel></div>' +
    '<div class="awb-modal-card" role="dialog" aria-modal="true">' +
      '<h3 class="awb-modal-h">Check your team list</h3>' +
      '<p class="awb-modal-count"><b>' + names.length + '</b> name' + plural + ' &rarr; <b>' + names.length + '</b> award' + plural + '</p>' +
      (priceTxt ? '<p class="awb-modal-price">' + awbEsc(priceTxt) + '</p>' : '') +
      (dupCount ? '<p class="awb-modal-warn">&#9888; ' + dupCount + ' duplicate name' + (dupCount > 1 ? 's' : '') + ' &mdash; you will get one award for each line. Go back if that is not intended.</p>' : '') +
      '<p class="awb-modal-sub">Every name below gets its own award, all on your one design. Read them back &mdash; this is exactly how they will be engraved.</p>' +
      '<ol class="awb-modal-list">' + listHtml + '</ol>' +
      '<div class="awb-modal-actions">' +
        '<button type="button" class="awb-btn awb-btn-ghost" data-cancel>&larr; Back to edit</button>' +
        '<button type="button" class="awb-btn awb-btn-primary" data-ok>Add ' + names.length + ' award' + plural + '</button>' +
      '</div>' +
    '</div>';
  function close(){ if(wrap.parentNode) wrap.parentNode.removeChild(wrap); document.removeEventListener("keydown", onKey); }
  function onKey(ev){ if(ev.key === "Escape") close(); }
  wrap.addEventListener("click", function(ev){
    if(ev.target.hasAttribute("data-cancel")) close();
    else if(ev.target.hasAttribute("data-ok")){ close(); onConfirm(); }
  });
  document.addEventListener("keydown", onKey);
  (root || document.body).appendChild(wrap);
}

/* ---------------- approve -> real add to cart (full-page multipart POST) ---------------- */
var form = document.getElementById("awb-form");
if(form){
  form.addEventListener("submit", function(e){
    // Block submit until the required pieces are present.
    if($("approve").disabled){ e.preventDefault(); return; }
    // Preview mode: section is not on a product, so there's no variant to add.
    if(form.getAttribute("data-has-variant") !== "1"){
      e.preventDefault();
      alert("This is a preview. Put the Award Builder section on a product to enable add-to-basket.");
      return;
    }
    // Personalised name awards: confirm the list & count before adding N awards to the basket.
    if(S.bundle === "names" && !form.__namesConfirmed){
      e.preventDefault();
      if(!S.names.length){ alert("Add at least one player name to your list first."); return; }
      showNamesConfirm(function(){
        form.__namesConfirmed = true;
        if(form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      return;
    }
    // Ensure the hidden property fields hold the very latest state, then let the
    // browser do a normal full-page POST to /cart/add (uploads the crest file).
    syncCartFields(awardParts(), bgById(S.bg));
    // Only submit the sponsor file when one is actually in use (avoids an empty property).
    $("i-sponsor").disabled = !(S.sponsorOn && S.sponsor);
    if($("i-sponsor2")) $("i-sponsor2").disabled = !(S.sponsorOn && S.sponsor2);

    // Capture the composed design and attach it to the order as a real file, then submit
    // for real. Falls back to a plain submit (spec + crest + proof URL) if unsupported.
    if(!form.__designDone && typeof html2canvas === "function" && $("p-design") && window.DataTransfer){
      e.preventDefault();
      var btn = $("approve"); var lbl = btn.textContent;
      btn.disabled = true; btn.textContent = "Preparing your design…";
      buildOverlay.show("Building your design…");
      captureDesignToInput(function(){
        form.__designDone = true;
        buildOverlay.done(); buildOverlay.allowNav();
        form.submit(); // native submit bypasses this handler and uploads crest + design
      }, function(i, n){ buildOverlay.progress(i, n); });
    }
  });
}

// Compose the finished design at high quality. The trick: html2canvas re-rasterizes a CSS
// background at its on-screen size and upscales it (soft). So instead we draw the FULL-RES
// background image straight onto the canvas (cover, matching the CSS), then capture only the
// text/crest/overlays over transparency and lay them on top — background stays near source
// quality. Rectangular by design (shields are clipped in the workshop). cb receives a canvas.
var DESIGN_W = 2000; // output width; portrait -> ~3000 tall, so backgrounds render near native

// Bake a soft drop shadow into each logo bitmap and place it behind the logo in the capture clone.
// (html2canvas ignores CSS filter:drop-shadow, so we render the shadow into real pixels instead.)
function logoShadowSpec(){
  var award = $("award");
  var ar = award.getBoundingClientRect();
  var specs = [];
  var strong = !!S.shadowOn;
  var imgs = award.querySelectorAll(".crest img, .sponsor img");
  Array.prototype.forEach.call(imgs, function(im){
    if(!im || !im.naturalWidth) return;
    var r = im.getBoundingClientRect();
    if(r.width < 2 || r.height < 2) return;              // hidden / not shown
    var iw = im.naturalWidth, ih = im.naturalHeight, m = Math.max(iw, ih);
    var pad = Math.round(m * (strong ? 0.17 : 0.12)) + 6;
    var c = document.createElement("canvas");
    c.width = iw + pad * 2; c.height = ih + pad * 2;
    var x = c.getContext("2d");
    x.shadowColor = strong ? "rgba(0,0,0,0.55)" : "rgba(0,0,0,0.42)";
    x.shadowBlur = Math.round(m * (strong ? 0.07 : 0.045)) + 5;
    x.shadowOffsetX = 0;
    x.shadowOffsetY = Math.round(m * (strong ? 0.035 : 0.022)) + 3;
    var url;
    try { x.drawImage(im, pad, pad, iw, ih); url = c.toDataURL("image/png"); }
    catch(e){ return; }                                  // tainted (shouldn't happen for uploads) -> skip
    var sx = r.width / iw, sy = r.height / ih;
    var dispW = (iw + pad * 2) * sx, dispH = (ih + pad * 2) * sy;
    var cx = (r.left - ar.left) + r.width / 2, cy = (r.top - ar.top) + r.height / 2;
    specs.push({ url: url, w: dispW, h: dispH, left: cx - dispW / 2, top: cy - dispH / 2 });
  });
  return specs;
}
function makeOnClone(specs){
  return function(doc){
    try {
      if(!specs || !specs.length) return;
      var award = doc.getElementById("awb-award"); if(!award) return;
      var lay = doc.getElementById("awb-layout");       // insert shadows just before the layout so they sit BEHIND the logos
      specs.forEach(function(sp){
        var img = doc.createElement("img");
        img.src = sp.url; img.setAttribute("aria-hidden", "true");
        img.style.cssText = "position:absolute;pointer-events:none;left:" + sp.left +
          "px;top:" + sp.top + "px;width:" + sp.w + "px;height:" + sp.h + "px;";
        if(lay) award.insertBefore(img, lay); else award.appendChild(img);
      });
    } catch(e){}
  };
}

function composeDesign(cb){
  var award = $("award");
  var r = award.getBoundingClientRect();
  var awW = r.width || 340, awH = r.height || (awW * 1.5);
  var bg = bgById(S.bg);
  var _onc = makeOnClone(logoShadowSpec());   // baked logo shadows for the capture clone

  function overlayThenCompose(drawBg){
    var bgEl = award.querySelector(".bg");
    var grain = award.querySelector(".grain");
    var prevBgVis = bgEl ? bgEl.style.visibility : "";
    var prevGrain = grain ? grain.style.display : "";
    if(bgEl) bgEl.style.visibility = "hidden";      // capture everything EXCEPT the background
    if(grain) grain.style.display = "none";         // mix-blend grain doesn't capture cleanly
    root.classList.add("awb-exporting");            // hide free-layer selection outlines in the capture
    var scale = DESIGN_W / awW;
    html2canvas(award, { backgroundColor: null, scale: scale, useCORS: true, logging: false, onclone: _onc }).then(function(layer){
      root.classList.remove("awb-exporting");
      if(bgEl) bgEl.style.visibility = prevBgVis;
      if(grain) grain.style.display = prevGrain;
      var c = document.createElement("canvas");
      c.width = DESIGN_W; c.height = layer.height;
      var ctx = c.getContext("2d");
      if(drawBg) drawBg(ctx, c.width, c.height);    // full-res background first
      else { ctx.fillStyle = "#0E1211"; ctx.fillRect(0, 0, c.width, c.height); }
      ctx.drawImage(layer, 0, 0, c.width, c.height);// text / crest / vignette on top
      cb(c);
    }).catch(function(){ root.classList.remove("awb-exporting"); if(bgEl) bgEl.style.visibility = prevBgVis; if(grain) grain.style.display = prevGrain; cb(null); });
  }

  if(bg && bg.image){
    var img = new Image();
    img.crossOrigin = "anonymous";                  // needed so drawImage doesn't taint the canvas
    img.onload = function(){
      overlayThenCompose(function(ctx, W, H){
        // cover + center, matching .bg { background-size:cover; background-position:center }
        var iw = img.naturalWidth, ih = img.naturalHeight;
        var s = Math.max(W / iw, H / ih);
        var dw = iw * s, dh = ih * s;
        ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
      });
    };
    img.onerror = function(){ overlayThenCompose(null); }; // couldn't load bg — still ship text/crest
    img.src = bg.image;
  } else {
    // gradient background (no image asset) — let html2canvas capture the whole thing
    var grain2 = award.querySelector(".grain"); var pg = grain2 ? grain2.style.display : "";
    if(grain2) grain2.style.display = "none";
    root.classList.add("awb-exporting");
    html2canvas(award, { backgroundColor: null, scale: Math.min(8, Math.max(2, DESIGN_W / awW)), useCORS: true, logging: false, onclone: _onc })
      .then(function(c){ root.classList.remove("awb-exporting"); if(grain2) grain2.style.display = pg; cb(c); })
      .catch(function(){ root.classList.remove("awb-exporting"); if(grain2) grain2.style.display = pg; cb(null); });
  }
}

/* ===== Print-ready artwork: a multi-month plaque pack becomes a 4-per-A4-page PDF ===== */
function printDimsFor(size){
  // physical print size incl. bleed (mm) — Slimline vs Standard plaque
  return (/slim/i.test(size || "")) ? { w: 93, h: 131 } : { w: 83, h: 134 };
}
// Print size (mm, incl. bleed) per product — a single-award PDF is generated at this exact size.
// NOTE: block-Standard and shield are ESTIMATES pending owner's exact numbers.
function printDimsFor2(type, size){
  var s = (size || "").toLowerCase();
  if(type === "plaque") return printDimsFor(size);                                    // slim 93x131, std 83x134 (known)
  if(type === "block")  return /large|lg/.test(s) ? { w: 102, h: 152 } : { w: 93, h: 133 };  // owner-confirmed (Std width 93 as of 2026-08-27)
  if(type === "shield") return { w: 95, h: 130 };                                     // unused (shields stay as image)
  return { w: 100, h: 150 };
}
// Crystal blocks print on the BACK and read through the glass — set block:true if the file must be mirrored.
var PRINT_MIRROR = { block: false, plaque: false, shield: false };
// Single award -> one-page print-ready PDF at the exact product size (falls back to JPEG if jsPDF fails).
function singlePdf(cb){
  ensureJsPdf(function(JsPDF){
    if(!JsPDF) return singleJpeg(cb);
    var dims = printDimsFor2(S.awardType, S.size), ratio = dims.h / dims.w;
    composeDesign(function(cv){
      if(!cv){ return singleJpeg(cb); }
      var img = cropToAspect(cv, ratio);
      var targetW = Math.round(dims.w / 25.4 * 300);                                  // 300 DPI, keeps the PDF light
      if(img.width > targetW * 1.15){
        var d = document.createElement("canvas");
        d.width = targetW; d.height = Math.round(targetW * img.height / img.width);
        d.getContext("2d").drawImage(img, 0, 0, d.width, d.height); img = d;
      }
      if(PRINT_MIRROR[S.awardType]){                                                  // flip horizontally for back-print products
        var m = document.createElement("canvas"); m.width = img.width; m.height = img.height;
        var mx = m.getContext("2d"); mx.translate(m.width, 0); mx.scale(-1, 1); mx.drawImage(img, 0, 0); img = m;
      }
      try{
        var pdf = new JsPDF({ orientation: dims.h >= dims.w ? "portrait" : "landscape", unit: "mm", format: [dims.w, dims.h] });
        pdf.addImage(img.toDataURL("image/jpeg", 0.9), "JPEG", 0, 0, dims.w, dims.h);
        cb(pdf.output("blob"), "pdf");
      }catch(e){ singleJpeg(cb); }
    });
  });
}
function ensureJsPdf(cb){ // lazy-load jsPDF only when a pack actually needs it
  if(window.jspdf && window.jspdf.jsPDF) return cb(window.jspdf.jsPDF);
  var url = root.getAttribute("data-jspdf"); if(!url) return cb(null);
  var s = document.createElement("script"); s.src = url;
  s.onload = function(){ cb(window.jspdf && window.jspdf.jsPDF); };
  s.onerror = function(){ cb(null); };
  document.head.appendChild(s);
}

/* ===== Personalised name awards: one Canva-ready image per name, zipped (JSZip) ===== */
function ensureJsZip(cb){
  if(window.JSZip) return cb(window.JSZip);
  var url = root.getAttribute("data-jszip"); if(!url) return cb(null);
  var s = document.createElement("script"); s.src = url;
  s.onload = function(){ cb(window.JSZip || null); };
  s.onerror = function(){ cb(null); };
  document.head.appendChild(s);
}
function sanitizeName(s){ return String(s).replace(/[^a-z0-9]+/gi, "-").replace(/^-+|-+$/g, "").toLowerCase() || "player"; }
function renderNames(names, cb, onProgress){ // compose the design once per name
  var out = [], saved = S.previewName, savedTok = (root.__awbTokens ? root.__awbTokens.nameGet() : null), savedW = DESIGN_W;
  DESIGN_W = Math.min(DESIGN_W, 1400);   // the names ZIP is downscaled to 1400 anyway
  (function next(i){
    if(i >= names.length){ DESIGN_W = savedW; S.previewName = saved; if(root.__awbTokens && savedTok!=null) root.__awbTokens.nameSet(savedTok); render(); return cb(out); }
    if(onProgress) onProgress(i, names.length);
    S.previewName = names[i]; if(root.__awbTokens) root.__awbTokens.nameSet(names[i]); render();
    composeDesign(function(c){ out.push({ name: names[i], canvas: c }); next(i + 1); });
  })(0);
}
function buildNamesZip(names, cb, onProgress){
  ensureJsZip(function(JSZip){
    if(!JSZip) return cb(null);
    renderNames(names, function(items){
      var valid = items.filter(function(it){ return it.canvas; });
      if(!valid.length) return cb(null);
      var zip = new JSZip(), pad = String(valid.length).length, pending = valid.length;
      valid.forEach(function(it, i){
        var cv = it.canvas, TW = 1400, img = cv;
        if(cv.width > TW){ // Canva-ready (screen res), kept light so the zip stays a sensible size
          var d = document.createElement("canvas");
          d.width = TW; d.height = Math.round(TW * cv.height / cv.width);
          d.getContext("2d").drawImage(cv, 0, 0, d.width, d.height);
          img = d;
        }
        var idx = String(i + 1); while(idx.length < pad) idx = "0" + idx;
        var fn = idx + "-" + sanitizeName(it.name) + ".jpg";
        img.toBlob(function(b){
          if(b) zip.file(fn, b);
          if(--pending === 0){
            zip.generateAsync({ type: "blob", compression: "STORE" }).then(function(zb){ cb(zb); }, function(){ cb(null); });
          }
        }, "image/jpeg", 0.86);
      });
    }, onProgress);
  });
}
function cropToAspect(src, ratioHW){ // centre-crop a canvas to height/width = ratioHW
  var sw = src.width, sh = src.height, sr = sh / sw, cw, ch;
  if(ratioHW > sr){ ch = sh; cw = sh / ratioHW; } else { cw = sw; ch = sw * ratioHW; }
  var c = document.createElement("canvas"); c.width = Math.round(cw); c.height = Math.round(ch);
  c.getContext("2d").drawImage(src, (sw - cw) / 2, (sh - ch) / 2, cw, ch, 0, 0, c.width, c.height);
  return c;
}
function renderMonths(months, cb, onProgress){ // compose the finished design once per month
  var out = [], saved = S.previewMonth, savedTok = (root.__awbTokens ? root.__awbTokens.monthGet() : null), savedW = DESIGN_W;
  DESIGN_W = Math.min(DESIGN_W, 1200);   // pack tiles get downscaled to print size anyway — lighter render = much faster
  (function next(i){
    if(i >= months.length){ DESIGN_W = savedW; S.previewMonth = saved; if(root.__awbTokens && savedTok!=null) root.__awbTokens.monthSet(savedTok); render(); return cb(out); }
    if(onProgress) onProgress(i, months.length);
    S.previewMonth = months[i]; if(root.__awbTokens) root.__awbTokens.monthSet(months[i]); render();
    composeDesign(function(c){ if(c) out.push(c); next(i + 1); });
  })(0);
}
// Lay canvases out as many-per-A4 as fit at true print size, paginating.
// Identical tiles (same canvas object) are cropped/encoded once.
function tilePdf(JsPDF, canvases, dims){
  var ratio = dims.h / dims.w;
  var pdf = new JsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  var cols = Math.max(1, Math.floor(210 / dims.w)), rows = Math.max(1, Math.floor(297 / dims.h)), per = cols * rows;
  var gx = (210 - cols * dims.w) / (cols + 1), gy = (297 - rows * dims.h) / (rows + 1);
  var targetW = Math.round(dims.w / 25.4 * 300); // 300 DPI, keeps the file light
  var cache = (typeof WeakMap !== "undefined") ? new WeakMap() : null;
  function dataFor(cv){
    if(cache && cache.has(cv)) return cache.get(cv);
    var img = cropToAspect(cv, ratio);
    if(img.width > targetW * 1.15){
      var d = document.createElement("canvas");
      d.width = targetW; d.height = Math.round(targetW * img.height / img.width);
      d.getContext("2d").drawImage(img, 0, 0, d.width, d.height); img = d;
    }
    var url = img.toDataURL("image/jpeg", 0.88);
    if(cache) cache.set(cv, url);
    return url;
  }
  canvases.forEach(function(cv, i){
    var pos = i % per;
    if(pos === 0 && i > 0) pdf.addPage();
    var col = pos % cols, rw = Math.floor(pos / cols);
    pdf.addImage(dataFor(cv), "JPEG", gx + col * (dims.w + gx), gy + rw * (dims.h + gy), dims.w, dims.h);
  });
  return pdf.output("blob");
}
function buildA4Pdf(months, cb, onProgress){ // month pack: one design per month, nested on A4
  ensureJsPdf(function(JsPDF){
    if(!JsPDF) return cb(null);
    renderMonths(months, function(canvases){
      if(!canvases.length) return cb(null);
      cb(tilePdf(JsPDF, canvases, printDimsFor(S.size)));
    }, onProgress);
  });
}
// Several copies of ONE design nested on A4 (e.g. qty 3 plaques -> 3-up on a single sheet).
function buildQtyPdf(qty, cb){
  ensureJsPdf(function(JsPDF){
    if(!JsPDF) return singlePdf(cb);
    composeDesign(function(cv){
      if(!cv) return singleJpeg(cb);
      var arr = []; for(var i = 0; i < qty; i++) arr.push(cv);
      cb(tilePdf(JsPDF, arr, printDimsFor2(S.awardType, S.size)), "pdf");
    });
  });
}
function isPlaquePack(){
  return S.awardType === "plaque" && S.bundle !== "single" && bundleMonths().length > 1;
}
// Order/download artwork: a 4-per-A4 PDF for a plaque pack, else a single JPEG.
function buildOrderArtwork(cb, onProgress){ // cb(blob, ext)
  if(S.bundle === "names" && S.names.length){ buildNamesZip(S.names, function(blob){ if(blob) cb(blob, "zip"); else singleJpeg(cb); }, onProgress); return; }
  if(isPlaquePack()){ buildA4Pdf(bundleMonths(), function(blob){ if(blob) cb(blob, "pdf"); else singleJpeg(cb); }, onProgress); return; }
  if(S.awardType === "block" || S.awardType === "plaque"){
    if(S.qty > 1) buildQtyPdf(S.qty, function(blob, ext){ if(blob) cb(blob, ext || "pdf"); else singlePdf(cb); });  // 3 copies -> one nested sheet
    else singlePdf(cb);                                                         // single copy -> tight one-up PDF
    return;
  }
  singleJpeg(cb);                                                               // shields keep the image for now
}
function singleJpeg(cb){
  composeDesign(function(canvas){
    if(!canvas || !canvas.toBlob) return cb(null);
    canvas.toBlob(function(b){ cb(b, "jpg"); }, "image/jpeg", 0.92);
  });
}
// Attach the artwork to the hidden Design file input so it rides on the order.
function captureDesignToInput(done, onProgress){
  buildOrderArtwork(function(blob, ext){
    if(!blob){ done(); return; }
    try{
      var dt = new DataTransfer();
      var suffix = ext === "pdf" ? (isPlaquePack() ? "-print-pack" : "-print-ready") : (ext === "zip" ? "-name-pack" : "-design");
      var mime = ext === "pdf" ? "application/pdf" : (ext === "zip" ? "application/zip" : "image/jpeg");
      var nm = ((S.club || "award") + suffix).replace(/[^a-z0-9\-]+/gi, "-").toLowerCase() + "." + ext;
      dt.items.add(new File([blob], nm, { type: mime }));
      $("p-design").files = dt.files;
    }catch(err){ /* leave the input empty; the order still has the spec + crest + proof URL */ }
    done();
  }, onProgress);
}

// Deep-link / product-aware default award type: ?type=block|plaque|shield wins,
// otherwise the product this builder sits on (data-default-type).
(function(){
  var urlType = null;
  try{ urlType = new URLSearchParams(window.location.search).get("type"); }catch(e){}
  var t = (urlType && AWARDTYPE_LABEL[urlType]) ? urlType : (root.getAttribute("data-default-type") || "block");
  if(AWARDTYPE_LABEL[t]){
    S.awardType = t;
    Array.prototype.forEach.call(root.querySelectorAll("[data-type]"), function(b){
      b.classList.toggle("is-active", b.getAttribute("data-type") === t);
    });
  }
})();
applyAwardType();
render();

// Web fonts load after first paint and change text widths — refit when ready,
// and again if the container is resized (e.g. phone rotate).
if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ render(); }); }
if(window.ResizeObserver){
  var ro = new ResizeObserver(function(){ fitLockup(); });
  ro.observe($("award"));
}

/* ===== Gate: three ways to start (built for you by the AI studio / build it yourself / request a design),
   plus upload your own. The studio is its own section below this one (#ff-ai-wrap in the template). ===== */
function showMode(m){
  var g = $("gate"), b = $("buildmode"), u = $("uploadmode"), a = $("aimode"), studio = document.getElementById("ff-ai-wrap");
  if(m === "ai" && !studio) m = "build"; // no studio on this page: fall back to the builder
  if(g) g.hidden = (m !== "gate");
  if(b) b.hidden = (m !== "build");
  if(u) u.hidden = (m !== "upload");
  if(a) a.hidden = (m !== "ai");
  if(studio) studio.hidden = (m !== "ai");
  if(m === "build"){
    applyLayoutMode();
    if(root.__awbGoStep) root.__awbGoStep(1); else { render(); fitLockup(); } // start the wizard at step 1
  }
  try{ root.scrollIntoView({ behavior: "smooth", block: "start" }); }catch(e){}
}
Array.prototype.forEach.call(root.querySelectorAll("[data-gate]"), function(el){
  el.addEventListener("click", function(){ showMode(el.getAttribute("data-gate")); });
});
// Links (and the app) can skip the choice: ?start=ai|build|upload. Waits for the page, as the studio comes after
// this section.
(function(){
  var start = null;
  try{ start = new URLSearchParams(window.location.search).get("start"); }catch(e){}
  if(start !== "ai" && start !== "build" && start !== "upload") return;
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", function(){ showMode(start); });
  else showMode(start);
})();

/* ===== Upload mode: "already have a design" — pick award + size + qty, upload, buy.
   Separate from the builder; reuses the same PRODUCTS/variant data + cart plumbing. ===== */
(function initUpload(){
  var bar = $("up-typebar"); if(!bar) return;
  var bundlebar = $("up-bundlebar");
  var up = { type: (root.getAttribute("data-default-type") || "block"), size: "", bundle: "single", qty: 1, hasFile: false };
  if(!AWARDTYPE_LABEL[up.type]) up.type = "block";

  function populate(){
    var sel = $("up-size"), prod = PRODUCTS[up.type]; if(!sel) return;
    sel.innerHTML = ""; var seen = {};
    (prod && prod.variants ? prod.variants : []).forEach(function(v){
      if(v.size == null || seen[v.size] || !packMatch(v.pack, "single")) return; seen[v.size] = 1;
      var o = document.createElement("option"); o.value = v.size; o.textContent = v.size; sel.appendChild(o);
    });
    var vals = Array.prototype.map.call(sel.options, function(o){ return o.value; });
    if(vals.indexOf(up.size) < 0) up.size = vals[0] || "";
    sel.value = up.size;
  }
  // Show season/year pack buttons only for products that actually have those packs (Plaque)
  function updateBundles(){
    var prod = PRODUCTS[up.type];
    var hasSeason = prodHasPack(prod, "season"), hasYear = prodHasPack(prod, "year");
    if(bundlebar){
      var s = bundlebar.querySelector('[data-upbundle="season"]'); if(s) s.hidden = !hasSeason;
      var y = bundlebar.querySelector('[data-upbundle="year"]');   if(y) y.hidden = !hasYear;
    }
    var wrap = $("up-bundlewrap"); if(wrap) wrap.hidden = !(hasSeason || hasYear);
    if((up.bundle === "season" && !hasSeason) || (up.bundle === "year" && !hasYear)) up.bundle = "single";
    if(bundlebar) Array.prototype.forEach.call(bundlebar.querySelectorAll("[data-upbundle]"), function(b){
      b.classList.toggle("is-active", b.getAttribute("data-upbundle") === up.bundle);
    });
  }
  function resolve(){
    var prod = PRODUCTS[up.type]; if(!prod || !prod.variants) return;
    function pick(kind){
      return prod.variants.filter(function(x){ return x.size === up.size && packMatch(x.pack, kind); })[0]
          || prod.variants.filter(function(x){ return packMatch(x.pack, kind); })[0];
    }
    var v = pick(up.bundle) || pick("single") || prod.variants.filter(function(x){ return x.size === up.size; })[0] || prod.variants[0];
    if(!v) return;
    if($("up-varid")) $("up-varid").value = v.id;
    if($("up-qty")) $("up-qty").value = up.qty;
    if($("up-price")) $("up-price").textContent = (up.qty > 1) ? (v.priceText + " each × " + up.qty) : v.priceText;
  }
  function validate(){
    var ok = up.hasFile;
    if($("up-add")) $("up-add").disabled = !ok;
    if($("up-warn")){ $("up-warn").hidden = ok; $("up-warn").textContent = ok ? "" : "Upload your design to continue."; }
  }

  Array.prototype.forEach.call(bar.querySelectorAll("[data-uptype]"), function(btn){
    btn.classList.toggle("is-active", btn.getAttribute("data-uptype") === up.type);
    btn.addEventListener("click", function(){
      up.type = btn.getAttribute("data-uptype");
      Array.prototype.forEach.call(bar.querySelectorAll("[data-uptype]"), function(b){ b.classList.toggle("is-active", b === btn); });
      populate(); updateBundles(); resolve();
    });
  });
  if(bundlebar) Array.prototype.forEach.call(bundlebar.querySelectorAll("[data-upbundle]"), function(btn){
    btn.addEventListener("click", function(){
      up.bundle = btn.getAttribute("data-upbundle");
      Array.prototype.forEach.call(bundlebar.querySelectorAll("[data-upbundle]"), function(b){ b.classList.toggle("is-active", b === btn); });
      resolve();
    });
  });
  if($("up-size")) $("up-size").addEventListener("change", function(){ up.size = this.value; resolve(); });

  function setQty(n){ up.qty = Math.max(1, Math.min(99, n)); if($("up-qtyval")) $("up-qtyval").textContent = up.qty; resolve(); }
  if($("up-qtyminus")) $("up-qtyminus").addEventListener("click", function(){ setQty(up.qty - 1); });
  if($("up-qtyplus"))  $("up-qtyplus").addEventListener("click",  function(){ setQty(up.qty + 1); });

  if($("up-file")) $("up-file").addEventListener("change", function(){
    var f = this.files && this.files[0]; up.hasFile = !!f;
    if(f){
      $("up-name").textContent = f.name;
      if(/^image\//.test(f.type)){ $("up-thumb").src = URL.createObjectURL(f); $("up-thumb").style.display = ""; }
      else { $("up-thumb").style.display = "none"; }
      $("up-chip").hidden = false;
    } else { $("up-chip").hidden = true; }
    validate();
  });
  if($("up-remove")) $("up-remove").addEventListener("click", function(){
    $("up-file").value = ""; up.hasFile = false; $("up-chip").hidden = true; validate();
  });

  var form = $("upform");
  if(form) form.addEventListener("submit", function(e){
    if(!up.hasFile){ e.preventDefault(); validate(); return; }
    if(form.getAttribute("data-has-variant") !== "1"){ e.preventDefault(); alert("This is a preview. Put the Award Builder on a product to enable checkout."); return; }
  });

  populate(); updateBundles(); resolve(); validate();
})();

/* ===== Wizard: Step 1 choose award -> 2 details -> 3 make it yours -> 4 review & order.
   Gates whole sections per step; every control keeps its own wiring. ===== */
(function initOnePage(){
  var buildmode = $("buildmode"); if(!buildmode) return;
  var progress = root.querySelector(".awb-wprogress"); if(progress) progress.style.display = "none";
  if($("wnav")) $("wnav").style.display = "none";
  root.classList.remove("awb-notype");

  // Two light pages: (1) choose award type -> Continue -> (2) the one-page builder.
  var typebar=$("typebar"), typehint=$("typehint"), typehero=$("typehero"), cont=$("typecontinue"), changeBtn=$("changetype");
  var productrow=$("productrow"), formWrap=root.querySelector(".wrap");
  function show(el,on){ if(el) el.style.display = on ? "" : "none"; }
  function setPage(p){
    var isType = (p === "type");
    show(typebar, isType); show(typehint, isType); show(typehero, isType); show(cont, isType);
    show(formWrap, !isType); show(changeBtn, !isType);
    show(productrow, isType);   // size/price + packs live on the type page, not above the editor
    if($("bundlebar")) $("bundlebar").style.display = isType ? "" : "none";
    if($("namesPanel")) $("namesPanel").style.display = isType ? "" : "none";
    root.classList.toggle("awb-typepage", isType);
    if(typeof applyAwardType === "function") applyAwardType();
    if(!isType){ render(); fitLockup(); }
    try{ buildmode.scrollIntoView({ behavior:"smooth", block:"start" }); }catch(e){}
  }
  root.__awbSetPage = setPage;   // the wizard reveals the builder via this
  if(cont) cont.addEventListener("click", function(){ setPage("build"); });
  if(changeBtn) changeBtn.addEventListener("click", function(){ setPage("type"); });
  root.__awbGoStep = function(){ setPage("type"); };   // gate entry -> pick award type -> structured builder
  setPage("type");
})();

/* ===== MOCKUP: see the customer's live design on their chosen real award ===== */
(function initMockup(){
  var mbtns=document.querySelectorAll(".awb-mockbtn"), modal=$("mockmodal"); if(!mbtns.length||!modal) return;
  var MOCKS; try{ var el=document.getElementById("awb-mockdata"); MOCKS=el?JSON.parse(el.textContent):null; }catch(e){ MOCKS=null; }
  if(!MOCKS){ MOCKS={}; } // never hide the button; handle missing data on click
  var base=$("mockbase"), dz=$("mockdesign"), gz=$("mockglossx");
  function adj(m){return[m[4]*m[8]-m[5]*m[7],m[2]*m[7]-m[1]*m[8],m[1]*m[5]-m[2]*m[4],m[5]*m[6]-m[3]*m[8],m[0]*m[8]-m[2]*m[6],m[2]*m[3]-m[0]*m[5],m[3]*m[7]-m[4]*m[6],m[1]*m[6]-m[0]*m[7],m[0]*m[4]-m[1]*m[3]];}
  function mmul(a,b){var c=[];for(var i=0;i<3;i++)for(var j=0;j<3;j++){var s=0;for(var k=0;k<3;k++)s+=a[3*i+k]*b[3*k+j];c[3*i+j]=s;}return c;}
  function mvec(m,v){return[m[0]*v[0]+m[1]*v[1]+m[2]*v[2],m[3]*v[0]+m[4]*v[1]+m[5]*v[2],m[6]*v[0]+m[7]*v[1]+m[8]*v[2]];}
  function basis(x1,y1,x2,y2,x3,y3,x4,y4){var m=[x1,x2,x3,y1,y2,y3,1,1,1];var v=mvec(adj(m),[x4,y4,1]);return mmul(m,[v[0],0,0,0,v[1],0,0,0,v[2]]);}
  function warp(elm,SW,SH,p){var s=basis(0,0,SW,0,0,SH,SW,SH);var d=basis(p[0],p[1],p[2],p[3],p[6],p[7],p[4],p[5]);var t=mmul(d,adj(s));for(var i=0;i<9;i++)t[i]=t[i]/t[8];
    elm.style.transform="matrix3d("+[t[0],t[3],0,t[6],t[1],t[4],0,t[7],0,0,1,0,t[2],t[5],0,t[8]].join(",")+")";}
  function pickId(){var t=S.awardType,sz=(S.size||"").toLowerCase();
    if(t==="shield")return "shield";
    if(t==="plaque")return /slim/.test(sz)?"plaque-slim":"plaque-std";
    return /large|lg/.test(sz)?"crystal-lg":"crystal-std";}
  function place(mk,srcH){var frame=$("mockframe"),w=frame.clientWidth,h=frame.clientHeight,q=mk.quad,p=[];
    for(var i=0;i<8;i+=2){p.push(q[i]*w);p.push(q[i+1]*h);}
    warp(dz,400,srcH,p);warp(gz,400,srcH,p);
    if(mk.type!=="shield"){var c=mk.round||[0,0,0,0],sc=Math.hypot(p[2]-p[0],p[3]-p[1])/400;
      dz.style.borderRadius=(c[0]*sc)+"px "+(c[1]*sc)+"px "+(c[2]*sc)+"px "+(c[3]*sc)+"px";}
    else dz.style.borderRadius="0";}
  function open(btn){
    var mk=MOCKS[pickId()]; if(!mk){ alert("Mockup preview isn't ready yet — please refresh the page and try again."); return; }
    var lbl=btn.innerHTML; btn.disabled=true; btn.textContent="Building your mockup\u2026";
    composeDesign(function(canvas){
      btn.disabled=false; btn.innerHTML=lbl;
      if(!canvas || !canvas.toDataURL){ alert("Couldn't build the mockup just now \u2014 please try again."); return; }
      var TW=900, scl=Math.min(1, TW/canvas.width), small=canvas;
      if(scl<1){ small=document.createElement("canvas"); small.width=Math.round(canvas.width*scl); small.height=Math.round(canvas.height*scl); small.getContext("2d").drawImage(canvas,0,0,small.width,small.height); }
      var url=small.toDataURL("image/jpeg",0.9), srcH=mk.srcH||600;
      base.src=mk.img;
      dz.style.height=srcH+"px"; gz.style.height=srcH+"px";
      dz.style.backgroundImage="url('"+url+"')";
      var msk=(mk.type==="shield"&&mk.mask)?("url('"+mk.mask+"')"):"none";
      dz.style.webkitMaskImage=msk; dz.style.maskImage=msk; gz.style.webkitMaskImage=msk; gz.style.maskImage=msk;
      gz.style.display=(mk.type==="glass")?"block":"none";
      var gn=$("mockglassnote"); if(gn) gn.classList.toggle("show", mk.type==="glass");
      modal.hidden=false;
      var fr=$("mockframe"); if(fr){ void fr.offsetWidth; }
      place(mk,srcH);
      requestAnimationFrame(function(){ place(mk,srcH); });
    });
  }
  Array.prototype.forEach.call(mbtns,function(b){ b.addEventListener("click", function(){ open(b); }); });
  Array.prototype.forEach.call(modal.querySelectorAll("[data-mockclose]"),function(x){ x.addEventListener("click",function(){ modal.hidden=true; }); });
  document.addEventListener("keydown",function(e){ if(e.key==="Escape" && !modal.hidden) modal.hidden=true; });
  // keep the step-1 hero image matched to the chosen type AND size (e.g. Large Crystal)
  function updateHero(){ var mk=MOCKS[pickId()], hi=$("typeheroimg"); if(mk&&hi&&mk.img) hi.src=mk.img; }
  Array.prototype.forEach.call(root.querySelectorAll("[data-type]"),function(b){ b.addEventListener("click", updateHero); });
  if($("size")) $("size").addEventListener("change", updateHero);
})();

/* ===== Free elements: add & freely drag any number of text lines + images over the award.
   Layers live inside #awb-award, so they bake into the exported design, mockup & PDFs. ===== */
(function initFreeLayers(){
  if(!root.classList.contains("awb-freemode")) return;   // free-canvas disabled — using structured layouts
  var host = $("freelayers"); if(!host) return;
  var award = $("award"), listEl = $("freelist"), editorEl = $("freeeditor"), hintEl = $("freehint");
  var _fid = 0; function nid(){ return ++_fid; }
  S.freeLayers = []; S.freeSel = null;

  function fstack(id){ for(var i=0;i<FONTS.length;i++){ if(FONTS[i].id===id) return FONTS[i].stack; } return "'Anton',sans-serif"; }
  function byId(id){ for(var i=0;i<S.freeLayers.length;i++){ if(S.freeLayers[i].id===id) return S.freeLayers[i]; } return null; }
  function layerEl(id){ return host.querySelector('.awb-flayer[data-id="'+id+'"]'); }
  function shadowFor(L){
    var parts=[];
    if(L.outline){
      var w=(L.outlineW||3)*0.1, c=L.outlineColor||"#0A0A0A", d=[[1,0],[-1,0],[0,1],[0,-1],[1,1],[1,-1],[-1,1],[-1,-1]];
      for(var i=0;i<d.length;i++){ parts.push((d[i][0]*w)+"cqw "+(d[i][1]*w)+"cqw 0 "+c); }
    }
    if(L.shadow) parts.push("0 0.6cqw 1.1cqw rgba(0,0,0,.55)");
    return parts.length?parts.join(","):"none";
  }
  function syncProp(){
    var p=$("p-freelayers"); if(!p) return;
    var txt=S.freeLayers.filter(function(L){return L.type==="text"&&L.text;}).map(function(L){return L.text;});
    var imgs=S.freeLayers.filter(function(L){return L.type==="image";}).length;
    p.value = S.freeLayers.length ? ("Text: "+(txt.join(" | ")||"none")+" · Images: "+imgs) : "";
  }
  function renderLayers(){
    host.innerHTML="";
    S.freeLayers.forEach(function(L){
      var el=document.createElement("div");
      el.className="awb-flayer awb-flayer-"+L.type+(L.id===S.freeSel?" is-sel":"");
      el.setAttribute("data-id",L.id);
      el.style.setProperty("--lx",(L.x||0)+"cqw");
      el.style.setProperty("--ly",(L.y||0)+"cqw");
      el.style.setProperty("--lr",(L.rotate||0)+"deg");
      if(L.type==="text"){
        el.style.setProperty("--lf",fstack(L.font));
        el.style.setProperty("--lsz",L.size);
        el.style.setProperty("--lc",L.color);
        el.style.setProperty("--lsh",shadowFor(L));
        el.textContent=L.text||" ";
      } else {
        el.style.setProperty("--lw",L.size+"cqw");
        var img=document.createElement("img"); img.src=L.src; img.alt=""; el.appendChild(img);
      }
      host.appendChild(el);
    });
    buildList(); syncProp();
    if(hintEl) hintEl.hidden = !S.freeLayers.length;
  }
  // A pack's month/name placeholder is locked (can't be deleted) while that pack is selected —
  // it still moves & edits freely, it just can't be removed (packs need it to swap per copy).
  function isMonthPack(){ return S.bundle==="season" || S.bundle==="year" || S.bundle==="custom"; }
  function isLocked(L){ return (L.isMonth && isMonthPack()) || (L.isName && S.bundle==="names"); }
  function buildList(){
    listEl.innerHTML="";
    S.freeLayers.forEach(function(L){
      var row=document.createElement("div"); row.className="awb-frow"+(L.id===S.freeSel?" is-sel":"");
      var locked=isLocked(L);
      row.innerHTML='<span class="fi">'+(L.type==="text"?"T":"🖼")+'</span><span class="fn"></span>'+(locked?'<span class="fl" title="Kept for your pack — can&#39;t be deleted">🔒</span>':'<button class="fx" type="button" aria-label="Remove">&times;</button>');
      row.querySelector(".fn").textContent = L.type==="text" ? (L.text||"Text") : "Image";
      row.addEventListener("click",function(e){ if(e.target.closest(".fx")) return; select(L.id); });
      var fx=row.querySelector(".fx"); if(fx) fx.addEventListener("click",function(e){ e.stopPropagation(); del(L.id); });
      listEl.appendChild(row);
    });
  }
  function flabel(t){ var l=document.createElement("span"); l.className="awb-freeflabel"; l.textContent=t; return l; }
  function rangeCtl(min,max,step,val,fn){ var r=document.createElement("input"); r.type="range"; r.className="range"; r.min=min; r.max=max; r.step=step; r.value=val; r.addEventListener("input",function(){ fn(+this.value); }); return r; }
  function colorCtl(val,fn){ var c=document.createElement("input"); c.type="color"; c.style.cssText="width:44px;height:34px;border:0;border-radius:8px;padding:0;background:none;cursor:pointer;vertical-align:middle"; c.value=val; c.addEventListener("input",function(){ fn(this.value); }); return c; }
  function toggleCtl(label,val,fn){
    var t=document.createElement("div"); t.className="toggle"; t.style.marginTop="12px";
    t.innerHTML='<div><div class="tg-t"></div></div><button class="switch" type="button" aria-pressed="'+String(!!val)+'"></button>';
    t.querySelector(".tg-t").textContent=label;
    t.querySelector(".switch").addEventListener("click",function(){ var on=this.getAttribute("aria-pressed")!=="true"; this.setAttribute("aria-pressed",String(on)); fn(on); });
    return t;
  }
  function setVar(L,name,val){ var el=layerEl(L.id); if(el) el.style.setProperty(name,val); }
  function buildEditor(){
    editorEl.innerHTML="";
    var L=byId(S.freeSel); if(!L) return;
    if(L.type==="text"){
      var inp=document.createElement("textarea"); inp.className="inp"; inp.rows=2; inp.value=L.text||""; inp.placeholder="Type your text — press Enter for a new line"; inp.style.resize="vertical";
      inp.addEventListener("input",function(){ L.text=this.value; var el=layerEl(L.id); if(el) el.textContent=this.value||" "; buildList(); syncProp(); });
      editorEl.appendChild(flabel("Text (Enter = new line)")); editorEl.appendChild(inp);
      editorEl.appendChild(flabel("Font"));
      var fsel=document.createElement("select"); fsel.className="inp";
      FONTS.forEach(function(f){ var o=document.createElement("option"); o.value=f.id; o.textContent=f.name; o.style.fontFamily=f.stack; if(f.id===L.font) o.selected=true; fsel.appendChild(o); });
      fsel.addEventListener("change",function(){ L.font=this.value; setVar(L,"--lf",fstack(this.value)); });
      editorEl.appendChild(fsel);
      editorEl.appendChild(flabel("Colour")); editorEl.appendChild(colorCtl(L.color,function(v){ L.color=v; setVar(L,"--lc",v); }));
      editorEl.appendChild(flabel("Size")); editorEl.appendChild(rangeCtl(3,26,0.5,L.size,function(v){ L.size=v; setVar(L,"--lsz",v); }));
      editorEl.appendChild(flabel("Rotate")); editorEl.appendChild(rangeCtl(-180,180,1,L.rotate||0,function(v){ L.rotate=v; setVar(L,"--lr",v+"deg"); }));
      editorEl.appendChild(toggleCtl("Drop shadow",L.shadow,function(v){ L.shadow=v; setVar(L,"--lsh",shadowFor(L)); }));
      editorEl.appendChild(toggleCtl("Outline",L.outline,function(v){ L.outline=v; setVar(L,"--lsh",shadowFor(L)); buildEditor(); }));
      if(L.outline){
        editorEl.appendChild(flabel("Outline colour")); editorEl.appendChild(colorCtl(L.outlineColor||"#0A0A0A",function(v){ L.outlineColor=v; setVar(L,"--lsh",shadowFor(L)); }));
        editorEl.appendChild(flabel("Outline thickness")); editorEl.appendChild(rangeCtl(1,8,0.5,L.outlineW||3,function(v){ L.outlineW=v; setVar(L,"--lsh",shadowFor(L)); }));
      }
    } else {
      editorEl.appendChild(flabel("Image size")); editorEl.appendChild(rangeCtl(6,90,1,L.size,function(v){ L.size=v; setVar(L,"--lw",v+"cqw"); }));
      editorEl.appendChild(flabel("Rotate")); editorEl.appendChild(rangeCtl(-180,180,1,L.rotate||0,function(v){ L.rotate=v; setVar(L,"--lr",v+"deg"); }));
      var bgBtn=document.createElement("button"); bgBtn.type="button"; bgBtn.className="chip"; bgBtn.style.marginTop="12px"; bgBtn.textContent="Remove background";
      var undo=document.createElement("button"); undo.type="button"; undo.className="chip"; undo.style.marginTop="8px"; undo.textContent="Undo"; undo.hidden=!L.origSrc;
      var msg=document.createElement("span"); msg.className="hint"; msg.style.display="block";
      bgBtn.addEventListener("click",function(){
        var im=new Image(); msg.textContent="Working…";
        im.onload=function(){ removeBackground(im,function(url,how){
          if(url){ if(!L.origSrc) L.origSrc=L.src; L.src=url; var el=layerEl(L.id); if(el){ var i=el.querySelector("img"); if(i) i.src=url; } undo.hidden=false; msg.textContent="Background removed ✓"; }
          else msg.textContent = how==="already" ? "Already has a transparent background." : how==="nocorner" ? "No plain background found — a PNG works best." : "Couldn't process that image.";
        }); };
        im.onerror=function(){ msg.textContent="Couldn't load that image."; };
        im.src=L.origSrc||L.src;
      });
      undo.addEventListener("click",function(){ if(L.origSrc){ L.src=L.origSrc; L.origSrc=null; var el=layerEl(L.id); if(el){ var i=el.querySelector("img"); if(i) i.src=L.src; } undo.hidden=true; msg.textContent="Reverted."; } });
      editorEl.appendChild(bgBtn); editorEl.appendChild(undo); editorEl.appendChild(msg);
    }
    if(isLocked(L)){
      var note=document.createElement("p"); note.className="hint"; note.style.marginTop="12px";
      note.innerHTML="🔒 This is your <b>"+(L.isMonth?"month":"name")+"</b> for the pack — it swaps on every award, so it can't be deleted. Move, resize &amp; restyle it wherever you like.";
      editorEl.appendChild(note);
    } else {
      var d=document.createElement("button"); d.type="button"; d.className="chip"; d.style.marginTop="12px"; d.textContent="🗑 Remove this "+(L.type==="text"?"text":"image");
      d.addEventListener("click",function(){ del(L.id); });
      editorEl.appendChild(d);
    }
  }
  function select(id){ S.freeSel=id;
    Array.prototype.forEach.call(host.children,function(el){ el.classList.toggle("is-sel",+el.getAttribute("data-id")===id); });
    buildList(); buildEditor();
  }
  function del(id){ var LL=byId(id); if(LL && isLocked(LL)) return; S.freeLayers=S.freeLayers.filter(function(L){return L.id!==id;}); if(S.freeSel===id) S.freeSel=S.freeLayers.length?S.freeLayers[S.freeLayers.length-1].id:null; renderLayers(); buildEditor(); }
  function addText(text,size,token){ var L={id:nid(),type:"text",text:(text!=null?text:"NEW TEXT"),font:(FONTS[0]?FONTS[0].id:"anton"),color:"#FFFFFF",size:(size||7),outline:false,outlineColor:"#0A0A0A",outlineW:3,shadow:false,rotate:0,x:0,y:0}; if(token==="month") L.isMonth=true; if(token==="name") L.isName=true; S.freeLayers.push(L); renderLayers(); select(L.id); }
  function addImage(src){ var L={id:nid(),type:"image",src:src,size:30,rotate:0,x:0,y:0}; S.freeLayers.push(L); renderLayers(); select(L.id); }

  // preset menu: pre-built award titles (stacked) + common lines + custom
  function awardPreset(a){ var lines=[a.a]; if(a.c) lines.push(a.c); if(a.b) lines.push(a.b); return lines.filter(Boolean).join("\n"); }
  var PRESETS=[]; (typeof AWARDS!=="undefined"?AWARDS:[]).forEach(function(a){ if(a.id!=="custom" && a.a) PRESETS.push({label:a.label, text:awardPreset(a), size:11}); });
  var FIELD_PRESETS=[
    {label:"Club / team name", text:"YOUR CLUB NAME", size:5},
    {label:"Player name (pack token)", text:"PLAYER NAME", size:7, token:"name"},
    {label:"Month (pack token)", text:"APRIL", size:11, token:"month"},
    {label:"Season", text:"SEASON 26/27", size:5}
  ];
  var addBtn=$("addtext"), menu=null;
  function menuItem(label,sub,fn){ var b=document.createElement("button"); b.type="button"; b.innerHTML=awbEsc(label)+(sub?('<small>'+awbEsc(sub)+'</small>'):''); b.addEventListener("click",function(){ hideMenu(); fn(); }); return b; }
  function menuHead(t){ var h=document.createElement("div"); h.className="pm-h"; h.textContent=t; return h; }
  function buildMenu(){
    menu=document.createElement("div"); menu.className="awb-presetmenu"; menu.hidden=true;
    menu.appendChild(menuHead("Your own"));
    menu.appendChild(menuItem("Custom text","Type anything",function(){ addText("NEW TEXT",7); }));
    if(PRESETS.length){ menu.appendChild(menuHead("Award titles")); PRESETS.forEach(function(p){ menu.appendChild(menuItem(p.label, p.text.replace(/\n/g," · "), function(){ addText(p.text,p.size); })); }); }
    menu.appendChild(menuHead("Common lines"));
    FIELD_PRESETS.forEach(function(p){ menu.appendChild(menuItem(p.label,null,function(){ addText(p.text,p.size,p.token); })); });
    (addBtn.parentNode||host).appendChild(menu);
  }
  function hideMenu(){ if(menu) menu.hidden=true; }
  function toggleMenu(){ if(!menu) buildMenu(); menu.hidden=!menu.hidden; }
  if(addBtn) addBtn.addEventListener("click",function(e){ e.stopPropagation(); toggleMenu(); });
  document.addEventListener("click",function(e){ if(menu && !menu.hidden && !(e.target.closest && e.target.closest(".awb-freeadd"))) hideMenu(); });
  if($("addimage")) $("addimage").addEventListener("click",function(){ $("freeimgfile").click(); });
  if($("freeimgfile")) $("freeimgfile").addEventListener("change",function(){ var f=this.files&&this.files[0]; if(!f) return; var rd=new FileReader(); rd.onload=function(){ addImage(rd.result); }; rd.readAsDataURL(f); this.value=""; });

  // free drag — empty areas pass through (pointer-events:none on host) so the crest under still drags
  var drag=null;
  host.addEventListener("pointerdown",function(e){
    var el=e.target.closest(".awb-flayer"); if(!el) return;
    var L=byId(+el.getAttribute("data-id")); if(!L) return;
    select(L.id);
    var r=award.getBoundingClientRect();
    drag={px:e.clientX,py:e.clientY,ox:L.x||0,oy:L.y||0,w:r.width||340,h:r.height||510,L:L,el:el};
    root.classList.add("awb-freedrag");
    try{ el.setPointerCapture(e.pointerId); }catch(_e){}
    e.preventDefault();
  });
  host.addEventListener("pointermove",function(e){
    if(!drag) return;
    var halfY=(drag.h/(drag.w||1))*50;
    drag.L.x=Math.max(-50,Math.min(50,drag.ox+(e.clientX-drag.px)/drag.w*100));
    drag.L.y=Math.max(-halfY,Math.min(halfY,drag.oy+(e.clientY-drag.py)/drag.w*100));
    drag.el.style.setProperty("--lx",drag.L.x+"cqw");
    drag.el.style.setProperty("--ly",drag.L.y+"cqw");
  });
  function endDrag(){ if(!drag) return; drag=null; root.classList.remove("awb-freedrag"); }
  host.addEventListener("pointerup",endDrag);
  host.addEventListener("pointercancel",endDrag);

  // seed a tidy default design (movable) so the canvas looks finished on arrival
  var _df=(FONTS[0]?FONTS[0].id:"anton");
  function seed(text,size,color,y,shadow){ return {id:nid(),type:"text",text:text,font:_df,color:color,size:size,outline:false,outlineColor:"#0A0A0A",outlineW:3,shadow:!!shadow,rotate:0,x:0,y:y}; }
  S.freeLayers=[
    seed("PLAYER\nOF THE\nMONTH",12,"#FFFFFF",-42,true),
    seed("YOUR CLUB NAME",5,"#FFFFFF",-22,false),
    seed("APRIL",13,"#FFFFFF",26,true),
    seed("SEASON 26/27",5,"#F0B62C",42,false)
  ];
  S.freeLayers[0].isTitle = true;   // wizard drives these
  S.freeLayers[1].isClub  = true;
  S.freeLayers[2].isMonth = true;   // this layer is the month token packs swap per copy
  S.freeSel=S.freeLayers[0].id;

  // expose token setters so the pack loops can swap the month/name placeholder per copy
  root.__awbTokens = {
    monthGet:function(){ for(var i=0;i<S.freeLayers.length;i++){ if(S.freeLayers[i].isMonth) return S.freeLayers[i].text; } return null; },
    monthSet:function(v){ var ch=false; S.freeLayers.forEach(function(L){ if(L.isMonth){ L.text=v; ch=true; } }); if(ch) renderLayers(); },
    nameGet:function(){ for(var i=0;i<S.freeLayers.length;i++){ if(S.freeLayers[i].isName) return S.freeLayers[i].text; } return null; },
    nameSet:function(v){ var ch=false; S.freeLayers.forEach(function(L){ if(L.isName){ L.text=v; ch=true; } }); if(ch) renderLayers(); },
    titleSet:function(v){ var ch=false; S.freeLayers.forEach(function(L){ if(L.isTitle){ L.text=v; ch=true; } }); if(ch) renderLayers(); },
    clubSet:function(v){ var ch=false; S.freeLayers.forEach(function(L){ if(L.isClub){ L.text=v; ch=true; } }); if(ch) renderLayers(); }
  };
  // let the bundle buttons refresh the list/editor so the lock state updates live
  root.__awbFreeRefresh = function(){ buildList(); buildEditor(); };

  renderLayers();
})();

/* ===== Quick-start wizard: 4 guided steps that fill the design, then reveal the builder ===== */
(function initWiz(){
  if(!root.classList.contains("awb-freemode")) return;   // wizard disabled — straight into the structured builder
  var wiz = $("wizard"); if(!wiz) return;
  var TOTAL = 4, step = 1, chosenType = null, chosenTitle = null;
  var typesEl=$("wiz-types"), titlesEl=$("wiz-titles"), clubInput=$("wiz-club");
  var crestChip=$("wiz-crestchip"), cresthumb=$("wiz-cresthumb"), crestname=$("wiz-crestname");
  var wbg=$("wiz-bggrid"), wbf=$("wiz-bgfilter"), wcat="All";
  var backBtn=$("wiz-back"), nextBtn=$("wiz-next"), skipBtn=$("wiz-skip"), fill=$("wiz-fill"), label=$("wiz-label");

  // step 1 — award type cards (reuse the builder's type images)
  var TYPE_DEFS=[{k:"block",label:"Crystal Block"},{k:"plaque",label:"MDF Plaque"},{k:"shield",label:"Award Shield"}];
  function typeImg(k){ var b=root.querySelector('#awb-typebar [data-type="'+k+'"] img'); return b?b.src:""; }
  TYPE_DEFS.forEach(function(t){
    var b=document.createElement("button"); b.type="button"; b.className="awb-wiz-type"; b.setAttribute("data-wtype",t.k); b.setAttribute("aria-pressed","false");
    var img=typeImg(t.k); b.innerHTML=(img?'<img src="'+img+'" alt="">':'')+'<span>'+t.label+'</span>';
    b.addEventListener("click",function(){
      chosenType=t.k; S.awardType=t.k;
      Array.prototype.forEach.call(typesEl.children,function(x){ x.setAttribute("aria-pressed",String(x===b)); });
      Array.prototype.forEach.call(root.querySelectorAll('#awb-typebar [data-type]'),function(tb){ tb.classList.toggle("is-active", tb.getAttribute("data-type")===t.k); });
      root.classList.remove("awb-notype");
      if(typeof applyAwardType==="function") applyAwardType();   // populate sizes + show/hide packs for this type
      render(); filterTitles(); updateWizHero();
    });
    typesEl.appendChild(b);
  });
  // move the size/price + pack selectors into the wizard's product step (out of the editor)
  (function(){ var slot=$("wiz-product"); if(!slot) return; var bb=$("bundlebar"), np=$("namesPanel"), pr=$("productrow"); if(bb) slot.appendChild(bb); if(np) slot.appendChild(np); if(pr) slot.appendChild(pr); })();
  // hero: show a REAL finished-award photo for the chosen type (falls back to the blank mockup)
  var heroImg=null;
  (function(){ var h=$("wiz-hero"); if(!h) return; heroImg=document.createElement("img"); heroImg.className="awb-wiz-heroimg"; heroImg.alt="Your chosen award"; h.appendChild(heroImg); })();
  function egKey(){ var t=S.awardType, sz=(S.size||"").toLowerCase(); if(t==="block") return /large|lg/.test(sz)?"block-lg":"block-std"; return t; }
  function updateWizHero(){
    if(!heroImg) return;
    var eg=root.getAttribute("data-eg-"+egKey());
    var src=(eg && eg.length) ? eg : typeImg(S.awardType);
    if(src){ heroImg.src=src; heroImg.style.display=""; } else { heroImg.style.display="none"; }
  }
  if($("size")) $("size").addEventListener("change", updateWizHero);   // Large vs Standard block swaps the photo
  // step 1 — award title presets
  (typeof AWARDS!=="undefined"?AWARDS:[]).forEach(function(a){
    if(a.id==="custom"||!a.a) return;
    var b=document.createElement("button"); b.type="button"; b.className="awb-wiz-title"; b.textContent=a.label; b.setAttribute("aria-pressed","false");
    b.__title=[a.a,a.c,a.b].filter(Boolean).join("\n");
    b.addEventListener("click",function(){ chosenTitle=b.__title; Array.prototype.forEach.call(titlesEl.children,function(x){ x.setAttribute("aria-pressed",String(x===b)); }); });
    titlesEl.appendChild(b);
  });
  if(titlesEl.firstChild){ titlesEl.firstChild.setAttribute("aria-pressed","true"); chosenTitle=titlesEl.firstChild.__title; }

  // A monthly pack (Season / Full year / Custom range) IS a Player of the Month set — restrict the title to that.
  function monthlyBundle(){ return S.bundle==="season" || S.bundle==="year" || S.bundle==="custom"; }
  function filterTitles(){
    var monthly=monthlyBundle(), potm=null;
    Array.prototype.forEach.call(titlesEl.children,function(b){
      var isPotm=/player of the month/i.test(b.textContent);
      if(isPotm) potm=b;
      b.style.display=(monthly && !isPotm) ? "none" : "";
    });
    if(monthly && potm){
      Array.prototype.forEach.call(titlesEl.children,function(x){ x.setAttribute("aria-pressed",String(x===potm)); });
      chosenTitle=potm.__title; if(root.__awbTokens) root.__awbTokens.titleSet(potm.__title);
    }
  }
  if($("bundleSelect")) $("bundleSelect").addEventListener("change", filterTitles);

  // step 2 — club name (live-updates the club layer)
  if(clubInput) clubInput.addEventListener("input",function(){ if(root.__awbTokens) root.__awbTokens.clubSet(this.value.trim()?this.value.trim().toUpperCase():"YOUR CLUB NAME"); });

  // step 3 — crest (reuse the builder's crest input + change handler)
  function syncCrestChip(){
    var has=!!S.crest;
    if(crestChip) crestChip.hidden=!has;
    if(has){ if(cresthumb) cresthumb.src=(S.crest.processedUrl||S.crest.url); if(crestname) crestname.textContent=(S.crest.name||"Crest"); }
    var bgrow=$("wiz-crestbgrow"); if(bgrow) bgrow.hidden=!has;
  }
  if($("wiz-crestbtn")) $("wiz-crestbtn").addEventListener("click",function(){ if($("i-crest")) $("i-crest").click(); });
  if($("i-crest")) $("i-crest").addEventListener("change",function(){ var m=$("wiz-crestbgmsg"); if(m) m.textContent=""; setTimeout(syncCrestChip,40); });
  if($("wiz-crestremove")) $("wiz-crestremove").addEventListener("click",function(){ if($("crestRemove")) $("crestRemove").click(); var m=$("wiz-crestbgmsg"); if(m) m.textContent=""; syncCrestChip(); });
  // reuse the builder's crest background remover
  if($("wiz-crestbg")) $("wiz-crestbg").addEventListener("click",function(){
    var msg=$("wiz-crestbgmsg"); if(msg) msg.textContent="Working…";
    if($("crestBgBtn")) $("crestBgBtn").click();
    setTimeout(function(){ syncCrestChip(); if(msg) msg.textContent=(S.crest&&S.crest.processedUrl)?"Background removed ✓":(($("crestBgMsg")&&$("crestBgMsg").textContent)||"No plain background found — a PNG works best."); }, 1300);
  });

  // step 4 — background grid (reuse BACKGROUNDS)
  var wcats=["All"]; BACKGROUNDS.forEach(function(b){ if(b.cat && wcats.indexOf(b.cat)<0) wcats.push(b.cat); });
  BACKGROUNDS.forEach(function(b){ if(b.animal && wcats.indexOf(b.animal)<0) wcats.push(b.animal); });
  wcats.forEach(function(c){ var b=document.createElement("button"); b.type="button"; b.textContent=c; b.setAttribute("aria-pressed",String(c===wcat)); b.addEventListener("click",function(){ wcat=c; Array.prototype.forEach.call(wbf.children,function(x){x.setAttribute("aria-pressed",String(x.textContent===c));}); drawWbg(); }); wbf.appendChild(b); });
  function wbgList(){ return BACKGROUNDS.filter(function(b){ return wcat==="All"||b.cat===wcat||b.animal===wcat; }); }
  function drawWbg(){
    if(!wbg) return; wbg.innerHTML="";
    wbgList().forEach(function(b){
      var el=document.createElement("button"); el.type="button"; el.className="awb-wiz-bgcell"; el.title=b.name; el.setAttribute("aria-pressed",String(S.bg===b.id));
      if(b.thumb){ var im=document.createElement("img"); im.loading="lazy"; im.decoding="async"; im.alt=""; im.src=b.thumb; el.appendChild(im); }   // lazy: only visible thumbs load
      else { el.style.backgroundImage=bgStyle(b); }
      el.addEventListener("click",function(){ S.bg=b.id; Array.prototype.forEach.call(wbg.children,function(x){x.setAttribute("aria-pressed","false");}); el.setAttribute("aria-pressed","true"); });
      wbg.appendChild(el);
    });
  }

  function commit(){
    if(step===1){
      if(chosenType){ S.awardType=chosenType; Array.prototype.forEach.call(root.querySelectorAll('#awb-typebar [data-type]'),function(b){ b.classList.toggle("is-active", b.getAttribute("data-type")===chosenType); }); root.classList.remove("awb-notype"); }
      if(chosenTitle && root.__awbTokens) root.__awbTokens.titleSet(chosenTitle);
    }
    if(step===2 && root.__awbTokens && clubInput) root.__awbTokens.clubSet(clubInput.value.trim()?clubInput.value.trim().toUpperCase():"YOUR CLUB NAME");
  }
  function apply(){
    Array.prototype.forEach.call(wiz.querySelectorAll(".awb-wiz-step"),function(s){ s.hidden=(+s.getAttribute("data-wiz")!==step); });
    if(fill) fill.style.width=(step/TOTAL*100)+"%";
    if(label) label.textContent="Step "+step+" of "+TOTAL;
    if(backBtn) backBtn.hidden=(step===1);
    if(skipBtn) skipBtn.hidden=(step!==3);
    if(nextBtn) nextBtn.innerHTML=(step===TOTAL)?"See my award &#10024;":"Next &rarr;";
    if(step===4) drawWbg();
  }
  function goNext(){ if(step===1 && !chosenType) return; commit(); if(step>=TOTAL){ finish(); return; } step++; apply(); try{ wiz.scrollIntoView({behavior:"smooth",block:"start"}); }catch(e){} }
  function finish(){ commit(); wiz.hidden=true; if(typeof drawBgGrid==="function") drawBgGrid(); if(root.__awbSetPage) root.__awbSetPage("build"); }
  if(nextBtn) nextBtn.addEventListener("click",goNext);
  if(backBtn) backBtn.addEventListener("click",function(){ if(step>1){ step--; apply(); } });
  if(skipBtn) skipBtn.addEventListener("click",function(){ if(step>=TOTAL) finish(); else { step++; apply(); } });

  root.__awbStartWizard=function(){
    step=1; chosenType=S.awardType||null;
    ["typebar","typehint","typehero","typecontinue","changetype"].forEach(function(id){ var e=$(id); if(e) e.style.display="none"; });
    ["productrow","bundlebar","namesPanel"].forEach(function(id){ var e=$(id); if(e) e.style.display=""; });
    var fw=root.querySelector(".wrap"); if(fw) fw.style.display="none";
    Array.prototype.forEach.call(typesEl.children,function(x){ x.setAttribute("aria-pressed",String(x.getAttribute("data-wtype")===S.awardType)); });
    if(typeof applyAwardType==="function") applyAwardType();
    filterTitles();
    updateWizHero();
    syncCrestChip();
    wiz.hidden=false; apply();
    try{ wiz.scrollIntoView({behavior:"smooth",block:"start"}); }catch(e){}
  };
})();
})();
